export default [
  {
    title: "Modele declarații pe proprie răspundere",
    slug: "modele-declaratii",
    doc_type: "STATIC_PAGE",
    doc_id: 210,
    active: true,
    display_order: 4,
    showInTopMenu: false,
    showInSideMenu: true,
    style: { "--highlightColor": "#F6DD62" },
    firstNodeId: null,
    content: [
      {
        title: "Modele declarații pe proprie răspundere ",
        display_order: 1,
        slug: "/",
        page: `
      <p>Pentru a veni în spijinul persoanelor care vin în România vă punem la dispoziție modelul de formular de triaj care trebuie înmânat reprezentantului DSP, la intrarea în țară.</p>
      <p>De asemenea, acest formular poate fi completat <a target="_blank" href="https://chestionar.stsisp.ro">on-line</a>.</p>

      <p style="background-color: #ffd738; padding: 10px;"> <a target="_blank" href="https://stirioficiale.ro/storage/Declaratie romana si engleza.pdf"> Descarcă de aici </a> modelul de formular de triaj </p>
      <p> Certificatele digitale care atestă vaccinarea, rezultatul negativ al testului RT –PCR și trecerea prin boală poate fi descărcat accesând următorul link: <a href="https://certificat-covid.gov.ro">https://certificat-covid.gov.ro</a> sau <a href="https://vaccinare-covid.gov.ro/">https://vaccinare-covid.gov.ro/</a>. </p>
      `,
      },
    ],
    form: null,
    buttons: null,
  },
  {
    title: "VOT 2020 - Ghid pentru alegători",
    slug: "ghid-alegatori",
    doc_type: "STATIC_PAGE",
    doc_id: 110,
    active: true,
    display_order: 100,
    showInTopMenu: false,
    showInSideMenu: false,
    style: { "--highlightColor": "#F6DD62" },
    firstNodeId: null,
    content: [
      {
        title: "VOT 2020 - Ghid pentru alegători",
        display_order: 1,
        slug: "/",
        page: `
      <p>
      În data de 6 decembrie 2020 vor avea loc alegeri pentru Camera Deputaților și Senatul României.
      </p>
      <p>
      Având în vedere contextul în care se desfășoară procesul electoral, au fost stabilite o serie de măsuri de prevenție pentru a reduce la minim riscul de contractare a noului tip de coronavirus , COVID – 19.
      </p>
      <p>
      Astfel, vă prezentăm setul de măsuri și un îndrumar despre lucrurile pe care trebuie să le faceți pentru a vota în siguranță.
      </p>
      <p>
        <b>ÎN EXTERIORUL SECȚIEI DE VOTARE</b>
        <ul>
          <li>În drum spre secția de votare purtați masca de protecție astfel încât să vă acopere nasul și gura, evitați să atingeți suprafețele comune.</li>
          <li>În sala de vot este permis accesul a maximum 5 alegători care pot fi prezenți simultan în secția de votare.</li>
          <li>În timp ce așteptați pentru a intra în secția de vot trebuie să respectați distanța recomandată față de celelalte persoane (minimum 1 metru).</li>
          <li>Respectați indicațiile personalului de pază și purtați masca de protecție întreaga perioadă în care așteptați pentru acces.</li>
        </ul>
      </p>
      <p>
      <b>ÎN INTERIORUL SECȚIEI DE VOTARE</b>
        <ul>
          <li>La intrarea în secția de votare, dezinfectați-vă mâinile folosind dispozitivele special instalate în acest scop. Personalul specializat va măsura temperatura corporală.</li>
        </ul>
        <b>Notă:</b> În cazul în care temperatura corporală măsurată depășește valoarea de 37,3 grade Celsius, alegătorii vor putea intra în sediul secției de vot purtând masca de protecție sanitară, evitând contactul cu suprafețele și păstrând distanța față de celelalte persoane. Alegătorii cu temperatura corporală peste 37,3 vor fi însoțiți de un membru din cadrul biroului
        electoral și vor vota în cabina de vot indicată de această persoană, respectând traseul de intrare și de ieșire stabilit de personalul tehnic.
        <ul>
          <li>După intrarea în secția de votare mergeți, menținând distanța față de celelalte persoane, spre biroul unde este instalată tableta conectată la Sistemul informatic de monitorizare a prezenței la vot și de prevenire a votului ilegal. Poziționați cartea de identitate pentru a fi scanată, conform recomandărilor personalului tehnic de specialitate care operează echipamentul IT.</li>
          <li>Menținând o distanța de minimum 1,5 metri față de operatorul tehnic al tabletei, îndepărtați parțial masca, pentru scurt timp, astfel încât să puteți fi identificați ca fiind persoana din actul de identitate. Apoi repoziționați masca astfel încât să acopere gura și nasul.</li>
          <li>După realizarea acestei proceduri, alegătorii se vor îndrepta către biroul/masa/banca la care se află membrul secției de votare pentru a semna în lista electorală. Alegătorii vor poziționa actul de identitate pe birou/masă/bancă astfel încât să nu fie necesar ca reprezentantul secției să atingă respectivul document.</li>
          <li>Ulterior, alegătorii vor prelua singuri, conform indicațiilor primite de la membrii biroului electoral, ștampila și buletinele de vot și vor intra în cabina de vot.</li>
          <li>După exercitarea dreptului la vot, prin introducerea buletinelor în urne, alegătorii se vor întoarce la biroul/masa/banca la care se află membrul secției de votare, vor preda ștampila folosită, își vor recupera actul de identitate și își vor aplica singuri pe acesta, conform indicațiilor primite, timbrul autocolant mențiunea votat.</li>
          <li>După aplicarea timbrului autocolant cu mențiunea votat pe documentul de identitate, alegătorii vor părăsi secția de votare urmărind culoarul special creat. Fluxul de ieșire va fi separat de cel de intrare.</li>
          <li>La ieșirea din secția de votare, alegătorii își vor dezinfecta mâinile folosind dispozitivele special instalate în acest scop.</li>
        </ul>
        <b>Notă:</b> Sălile în care se desfășoară procesul electoral sunt dezinfectate înainte de începerea votului și după finalizarea scrutinului. De asemenea, se va asigura aerisirea sălii prin menținerea deschisă a ferestrei sau ferestrelor pe toată durata votării și a desfășurării activității, iar acolo unde acest lucru nu este posibil sala se va aerisi la fiecare două ore pentru cel puțin 10 minute.
      </p>
      <p>
      <b>IMPORTANT</b>
        <ul>
          <li>Persoanele aflate în izolare sau carantină, la domiciliu sau instituționalizată, nu se pot deplasa la sediul unei secții de votare însă, în cazul în care doresc să voteze, pot solicita urna mobilă.</li>
          <li>Cererea de vot prin intermediul urnei speciale poate fi depusă prin intermediul oricărei persoane, trebuie să fie datată şi semnată olograf de către alegătorul care solicită urna specială şi cuprinde, în mod obligatoriu: numele, prenumele, codul numeric personal, domiciliul sau reşedinţa, conform menţiunilor din actul de identitate ori dovada de reşedinţă, după caz, adresa imobilului unde se solicită deplasarea echipei, seria şi numărul actului de identitate, precum şi numărul de telefon.</li>
          <li>Cetăţenii cu drept de vot aflaţi în carantină sau izolare pot transmite, prin mijloace electronice, biroului electoral de circumscripţie sau oficiului electoral cererile de vot prin
          intermediul urnei speciale şi copiile actelor necesare, <u>până cel mai târziu în data de 4 decembrie 2020</u>.</li>
          <li>Cererea pentru urna specială va fi însoțită de copia deciziei de carantină emisă de direcţia de sănătate publică sau biletul de externare din unitatea sanitară care confirmă diagnosticul şi indicaţia de izolare, decizia de izolare emisă de direcţia de sănătate publică, rezultatul testării COVID-19 RT-PCR (pozitiv) din ultimele 14 zile.</li>
          <li>Cetăţenii cu drept de vot aflaţi în izolare sau carantină cărora nu li s-au eliberat documentele prevăzute mai sus, pot transmite, prin orice mijloace, birourilor electorale de
          circumscripţie sau oficiilor electorale, după caz, cereri privind emiterea documentelor necesare exercitării votului prin intermediul urnei speciale. Birourile electorale de circumscripţie şi oficiile electorale asigură transmiterea către direcţiile de sănătate publică a listei persoanelor care au transmis cereri, în vederea luării măsurilor necesare pentru emiterea urgentă a documentelor necesare exercitării dreptului de vot prin intermediul urnei speciale.</li>
        </ul>
      </p>
  `,
      },
    ],
    form: null,
    buttons: null,
  },
  {
    title: "Carantină Timișoara",
    slug: "carantina-timisoara",
    doc_type: "STATIC_PAGE",
    doc_id: 111,
    active: true,
    display_order: 0,
    showInTopMenu: false,
    showInSideMenu: false,
    style: { "--highlightColor": "#F6DD62" },
    firstNodeId: null,
    content: [
      {
        title: "CARANTINĂ TIMIȘOARA: Restricții, reguli, declarații, informații utile",
        display_order: 1,
        slug: "/",
        page: `
      <p>Orașele carantinate în perioada <b>8-22 martie 2021</b>: </p>
      <p>
        <ul>
          <li>Timișoara</li>
          <li>Moșnița Nouă</li>
          <li>Ghiroda</li>
          <li>Giroc</li>
          <li>Dumbrăvița</li>
        </ul>
      </p>
      <p><h3>Restricțiile care se aplică</h3></p>
      <p>În perioada <b>8-22 martie 2021</b> circulația și staționarea persoanelor în orice spațiu public din interiorul zonelor declarate în carantină sunt interzise cu excepția unor motive justificate, dovedite prin declarațiile pe proprie răspundere sau prin adeverințele de angajator, respectiv legitimațiile de serviciu</p>
      <p style="background-color: #FFD738; padding: 10px;"> <a target="_blank" href="https://stirioficiale.ro/storage/declaratie-proprie-raspundere-carantina-timisoara.pdf"> Descarcă de aici</a> modelul de declarație pe proprie răspundere pentru perioada de carantină - pe timp de zi</p>
      <p style="background-color: #FFD738; padding: 10px;"> <a target="_blank" href="https://stirioficiale.ro/storage/adeverinta-angajator-timisoara.pdf"> Descarcă de aici</a> modelul de adeverință de angajator pentru perioada de carantină - pe timp de zi </p>
      <p style="background-color: #FFD738; padding: 10px;"> <a target="_blank" href="https://stirioficiale.ro/storage/0611_Model Declaratie proprie Raspundere_noapte_timisoara.pdf">Descarcă de aici</a> modelul de declarație pe proprie răspundere pentru perioada de carantină - pe timp de noapte</p>
      <p style="background-color: #FFD738; padding: 10px;"> <a target="_blank" href="https://stirioficiale.ro/storage/0611_Adeverinta pentru angajatori_noapte_timisoara.pdf">Descarcă de aici</a> modelul de adeverință de angajator pentru perioada de carantină - pe timp de noapte </p>
      <p>Este obligatorie purtarea măștii în spațiile publice închise sau deschise, în transportul în comun sau la locul de muncă pentru toate persoanele peste 5 ani.</p>
      <p>Toate instituțiile de învățământ vor funcționa exclusiv online.</p>
      <p>Persoanele peste 65 de ani se pot deplasa pentru cumpărăturile de bază doar în intervalul 10.00-13.00</p>
      <p>Persoanele sub 65 de ani se pot deplasa pentru cumpărăturile de bază între 06.00-10.00 și 13.00-20.00</p>
      <p>Circulația persoanelor în grupuri pietonale mai mari de 6 persoane care nu aparțin aceleiași familii în interiorul localităților este interzisă.</p>
      <p>Toate centrele comerciale și mall-urile vor fi închise în weekend cu excepția magazinelor alimentare, a farmaciilor, a curățătoriilor și magazinelor care vând mâncare pentru animale de companie.</p>
      <p>Conform <a target="_blank" href="https://covid19.primariatm.ro">covid19.primariatm.ro</a>: ”Conform excepțiilor din <a target="_blank" href="https://stirioficiale.ro/storage/HOTARAREA-32-din-data-de-06.03.2021.pdf"> Hotărârea 32/06.03.2021 </a>, sunt permise deplasările scurte în apropierea locuinței legate de activitatea fizică individuală a persoanelor (cu excluderea oricăror activități sportive de echipă). Sunt interzise toate activităţile şi competiţiile sportive, individuale sau colective, care se desfăşoară în spații închise sau deschise, inclusiv săli de fitness, cu excepţia evenimentelor profesioniste organizate de federaţiile de profil.”</p>
      <p>Persoanele care nu au domiciliul în Timișoara pot să tranziteze zona carantinată, dar nu au voie să se oprească între localități iar autoritățile locale și Inspectoratul Județean de Poliție stabilesc care sunt căile de circulație pentru tranzit.</p>
      `,
      },
    ],
    form: null,
    buttons: null,
  },
  {
    title: "Transmitere și simptome",
    slug: "transmitere-si-simptome",
    doc_type: "STATIC_PAGE",
    doc_id: 101,
    active: true,
    display_order: 5,
    showInTopMenu: true,
    showInSideMenu: true,
    firstNodeId: null,
    content: [
      {
        title: "Transmitere și simptome",
        display_order: 1,
        slug: "/",
        page: `<p style="background-color: #ffd738; padding: 10px; font-weight: bold;">COVID-19 este o boală nouă. Încă descoperim cum se transmite, cât de grave sunt consecințele și în ce măsură se poate răspândi în România. Vom ține această pagină actualizată cu ultimele informații, pe măsură ce ele apar.</p>

      <h3>Cum se transmite COVID-19</h3>

      <p>Transmiterea virusului SARS-CoV-2 se face pe cale respiratorie, prin picături de secreţie, produse când o persoană infectată tuşeşte, strănută, vorbește sau respiră și se află în imediata apropiere a altor persoane.</p>
      <p>Virusul a fost, de asemenea, izolat din materiile fecale ale cazurilor infectate, indicând că transmiterea fecală-orală ar putea fi, de asemenea, o cale de infecție. </p>
      <p>Transmiterea indirectă prin obiecte contaminate este de asemenea posibilă. Picăturile de secreție pot ateriza pe suprafețe cu care alții intră în contact și sunt apoi infectați atunci când își ating nasul, gura sau ochii. Virusul poate supraviețui pe suprafețe, între câteva ore (cupru, carton) până la câteva zile (plastic și oțel inoxidabil). Cu toate acestea, cantitatea de virus viabil scade în timp și este posibil să nu fie întotdeauna prezentă în cantități suficiente pentru a provoca infecția.</p>
      <p>Dovezile actuale privind transmiterea în uter a virusului SARS-CoV-2 sunt neconcludente. Un număr limitat de cazuri au fost raportate, cu stare generală bună și fără boală severă pentru nou-născut.</p>
      <p>Perioada de incubație pentru COVID-19 (adică timpul dintre expunerea la virus și apariția simptomelor) este în prezent estimată a fi între 2 și 14 zile.</p>
      
      <h4>Poate fi cineva contagios chiar daca nu are niciun simptom?</h4>

      <p>Perioada de contagiozitate poate începe cu aproximativ două zile înainte de apariția simptomelor, dar persoanele sunt cel mai infecțioase în timpul perioadei simptomatice, chiar dacă simptomele sunt ușoare și nespecifice. Perioada infecțioasă este estimată să dureze opt până la 10 zile în cazurile moderate și până la două săptămâni în medie în cazurile severe. </p>
      <p>Virusul poate fi transmis atunci când persoanele infectate prezintă simptome precum tuse. O persoană care este infectată poate transmite, de asemenea, virusul cu până la două zile înainte de a prezenta simptome; măsura în care astfel de infecții asimptomatice contribuie la transmiterea generală nu este clară în prezent.</p>

      <h4>Simptomatologie</h4>
      <p>Simptomele infecției cu virusul SARS-CoV-2 variază în severitate, de la forme asimptomatice până la forme grave, soldate cu deces.</p>
      <p>Cele mai frecvente simptome sunt: febră, tuse, durere în gât, slăbiciune generală, oboseală și durere musculară. Anosmia (pierderea simțului mirosului) și ageuzia (pierderea simțului gustului) au fost recunoscute ca simptome in cadrul infecției cu virusul SARS-CoV-2.</p>
      <p>Cele mai severe cazuri pot dezvolta pneumonie, sindrom de detresă respiratorie acută și alte complicații, toate putând duce la deces.</p>
      <p>Riscul de a dezvolta forme severe il au persoanele cu vârsta înaintată. Persoanele cu vârsta peste 60 de ani și cele cu multiple condiții de sănătate subiacente (de exemplu, hipertensiune arterială, diabet, boli cardiovasculare, boli respiratorii cronice și imunosupresie) sunt considerate a fi mai expuse riscului de a dezvolta simptome severe. Bărbații din aceste grupuri par, de asemenea, să prezinte un risc mai mare decât femeile.</p>

      <p style="background-color: #ffd738; padding: 10px; font-weight: bold;">Datele existente pâna acum indică faptul că femeile însărcinate care s-au infectat cu virusul SARS-CoV-2 prezintă simptome similare cu cele care nu sunt gravide. Femeile gravide care au diabet zaharat și / sau sunt obeze pot prezenta forme clinice severe de boala.</p>

      <h4>Există vreun tratament?</h4>

      <p>Nu exista un tratament specific, acesta este in general simptomatic.Tratamentul pentru persoanele care sunt spitalizate cu infectie SARS-CoV-2 severă este în mare măsură de susținere (de exemplu, oxigenoterapie, gestionarea fluidelor), utilizând în principal o abordare simptomatică, vizând mai degrabă simptomele decât virusul.</p>
      <p>Mai multe produse farmaceutice au fost studiate sau sunt în prezent studiate în cadrul studiilor clinice pentru a evalua siguranța și eficacitatea acestora ca tratamente potențiale pentru COVID-19. Există dovezi că utilizarea corticoterapiei este benefică pentru boala severă. Mai multe medicamente și preparate de anticorpi sunt în curs de evaluare.</p>


      <h4>Măsuri de prevenire a infecției cu SARS-CoV-2</h4>
      <h4>A.	Măsuri nespecifice</h4>

      <p>Principalele modalități prin care puteți evita infectarea sunt păstrarea distanței față de ceilalți (1,5-2 m), purtarea unei măști în situații în care distanța fizică nu este posibilă și menținerea mâinilor curate.
        <ul>
          <li>1. Evitați locurile aglomerate;</li>
          <li>2. Evitați contactul apropiat cu persoanele care tușesc și au febră; </li>
          <li>3. Utilizați măștile de protecție, atât în interior (de exemplu, supermarketuri, magazine și transport public), cât și în exterior în situații aglomerate (piețe publice, târguri), mai ales în zonele cu incidență crescută a infecției și când distanța fizică nu poate fi garantată;</li>
          <li>4. Spălați-vă des pe mâini cu apă și săpun timp de cel puțin 20 de secunde, sau cu soluții pe bază de alcool; </li>
          <li>5. Evitați să vă atingeți fața cu mâinile nespălate, virusul pătrunde în corp prin nas, gură și / sau ochi</li>
          <li>6. Tușiți sau strănutați în cot sau folosiți un șervețel de unică folosință. Dacă utilizați un șervețel, aruncați-l cu atenție după o singură utilizare și apoi spălați-vă pe mâini. </li>
          <li>7. Dacă vă simțiți rău, rămâneți acasă. Dacă dezvoltați orice simptom care sugerează infecția cu virusul SARS-CoV-2, contactați imediat medicul dumneavoastra pentru sfaturi.</li>
          <li>8. Autoizolați-vă dacă știți că sunteți infectat cu virusul SARS-CoV-2 sau dacă aveți simptome ale unei infecții respiratorii acute, cum ar fi tuse, febră, dureri în gât sau secreții nazale.</li>
        </ul>
      </p>

    <h4>B. Măsuri specifice- Vaccinarea</h4>

      <p>Vaccinurile COVID-19 își propun să prevină infecția prin declanșarea unui răspuns imun. Vaccinurile sigure și eficiente sunt un instrument puternic în asigurarea sănătății publice, iar disponibilitatea lor reprezintă un moment important în eforturile de control al pandemiei.</p>
      <p>Vaccinurile COVID-19 sunt dezvoltate urmând aceleași cerințe legale pentru calitate, siguranță și eficacitate ca și pentru toate celelalte vaccinuri. </p>
      <p>Agenția Europeană pentru Medicamente (EMA) evaluează vaccinurile COVID-19 în raport cu aceleași standarde înalte ca și pentru toate celelalte vaccinuri înainte ca acestea să fie autorizate pentru utilizare în UE de către Comisia Europeană.</p>
      <p>Informații despre vaccinurile COVID-19 aprobate și utilizate in Romania precum si raspunsuri la întrebarile dvs despre vaccinare gasiti pe <a href="https://vaccinare-covid.gov.ro/vaccinuri-autorizate/">site-ul Comitetului Național de Coodonare a Activitătii de Vaccinare (CNCAV)</a></p>
  `,
      },
    ],
    form: null,
    buttons: null,
  },
  {
    title: "Cum ne protejăm?",
    slug: "cum-ne-protejam",
    doc_type: "STATIC_PAGE",
    doc_id: 102,
    showInTopMenu: true,
    showInSideMenu: true,
    active: false,
    display_order: 6,
    content: [
      {
        title: "Cum ne protejăm?",
        display_order: 1,
        slug: "/",
        page: `<p style="background-color: #ffd738; padding: 10px; font-weight: bold;">Vârstnicii și persoanele cu afecțiuni medicale cronice precum boli de inimă, boli pulmonare sau diabet par să aibă un risc mai ridicat pentru complicații severe din cauza îmbolnăvirii cu COVID-19.</p>

         <h3 id="cum-se-raspandeste">Cum se răspândește</h3>
         <p>În acest moment, nu există un vaccin dezvoltat specific pentru a preveni îmbolnăviriea cu COVID-19. Cea mai bună cale de a preveni îmbolnăvirea este de a evita expunerea la acest virus. Se pare că virusul se răspândește, în mod principal, de la persoană la persoană.</p>
         <p><b>Contact direct</b></p>
         <ul>
          <li>între persoane care sunt în contact strâns (strângerea mâinilor, îmbrățișările, sărutul obrajilor sau al mâinilor, atingerea fețelor cu mâinile).</li>
          <li>prin picăturile produse atunci când o persoană infectată tușește sau strănută. (Aceste picături pot ajunge în gurile sau nasurile persoanelor care se află în apropiere sau pot fi inhalate în plămâni).</li>
         </ul>
         <p><b>Contact indirect</b></p>
         <ul>
          <li>atingerea suprafețelor care sunt atinse în mod frecvent și de alte persoane, precum: balustrade, clanțe, mânere, butoane de lift sau de acces, etc.</li>
          <li>NU folosi aceeași  sticlă/pahar cu alte persoane și nu folosi aceleași tacâmuri.</li>
          <li>Limitați folosirea bancnotelor și a monedelor, optând pentru plăți cu cardul/telefonul sau plăți on-line (Transmiterea virușilor se realizează într-o pondere semnificativă prin intermediul banilor, cu care ia contact, statistic, un număr foarte mare de persoane.)</li>
         </ul>

         <p style="background-color: #ffd738; padding: 10px; font-weight: bold;">ATENȚIE</br>
         Țineți cont de faptul că nu în toate cazurile infectarea cu noul coronavirus (COVID-19) este vizibilă prin simptome specifice (tuse, febră, dificultăți în respirație). Virusul poate fi răspândit inclusiv de persoane aparent sănătoase, care nu au cunoștință de faptul că sunt purtători ai noului coronavirus.</p>
         `,
      },
      {
        title: "Ce măsuri trebuie să iei pentru a te proteja",
        display_order: 2,
        slug: "masuri-protejare",
        page: `
         <h3 id="masuri-protejare">Măsuri pentru a te proteja</h3>
         <ul>
          <li>Spală-te des pe mâini cu apă și săpun timp de cel puțin 20 de secunde, mai ales după ce ai fost într-un loc public sau după ce îți sufli nasul, tușești sau strănuți. (pentru a te șterge pe mâini folosește, de preferat, prosoape de hârtie).</li>
          <li>Dacă nu sunt disponibile apa și săpunul, utilizează un produs de dezinfectare a mâinilor. Acoperă cu lichidul toată suprafața mâinilor și freacă-ți mâinile până când se simt uscate.</li>
          <li>NU intra în contact direct cu membrii familiei, atunci când revii la domiciliu, înainte de igienizarea mâinilor.</li>
          <li>Dacă strănuți sau tușești acoperă-ți gura și nasul cu un șervețel de unică folosință, pe care ai grijă să îl arunci imediat la coșul de gunoi.</li>
          <li>Evită să îți atingi ochii, nasul și gura cu mâinile neigienizate.</li>
          <li>Distanțează-te de ceilalți în cazul în care COVID-19 se răspândește în propria comunitate. Acest lucru este cu atât mai important pentru persoanele care prezintă un risc mai mare de îmbolnăvire.</li>
         </ul>
         `,
      },
      {
        title: "Ce măsuri trebuie să iei pentru a-i proteja pe ceilalți",
        display_order: 3,
        slug: "masuri-protejare-altii",
        page: `
         <h3 id="masuri-protejare-altii">Măsuri pentru a-i proteja pe ceilalți</h3>
         <ul>
          <li>Evită, cu prioritate, expunerea persoanelor în vârstă (peste 65 de ani) și a celor cu imunitate scăzută/boli asociate către alte persoane cu simptome de gripă sau răceală, în zone aglomerate sau zone cu trafic intens de persoane.</li>
          <li>Rămâi în casă dacă ai simptome de gripă sau răceală (tuse, febră, dificultăți în respirație) și sună medicul de familie pentru a solicita sfaturi, <span style="background-color: #ffd738">nu merge din primul moment la unitățile de urgență</span>. (Există riscul, în cazul în care sunteți purtători al virusului, să transmiteți și altor persoane noul coronavirus. Este de preferat să rămâi la domiciliu, iar transferul către spital să se realizeze în mod organizat, respectând toate măsurile de izolare).</li>
          <li>Acoperă-ți gura și nasul cu un șervețel atunci când tușești sau strănuți, sau folosește interiorul cotului. Aruncă apoi șervețelele folosite la gunoi imediat. Spală-te imediat pe mâini cu apă și săpun, timp de cel puțin 20 de secunde. Dacă nu sunt disponibile apa și săpunul, utilizează un produs de dezinfectare a mâinilor care conține cel puțin 60% alcool.</li>
          <li>Dacă strănuți sau tușești acoperă-ți gura și nasul cu un șervețel de unică folosință, pe care ai grijă să îl arunci imediat la coșul de gunoi.</li>
         </ul>

         <p style="background-color: #ffd738; padding: 10px;"><b>Dacă ești bolnav</b></br>
           Trebuie să porți o mască atunci când ești în preajma altor persoane (de exemplu, atunci când ești în aceeași cameră sau mașină), precum și înainte de a intra într-un cabinet medical. Persoanele care te îngrijesc ar trebui să poarte masca de protecție atunci când intră în spațiul în care ești.
         </p>

         <p style="background-color: #E5F9FE; padding: 10px;"><b>Dacă nu ești bolnav</b></br>
           Trebuie să porți o mască atunci când ești în preajma altor persoane. Masca de protecție/masca chirurgicală îi protejează pe cei din jurul tău, în cazul în care ai simptome de gripă sau răceală, întrucât previne răspândirea virusului pe cale respiratorie. Masca de protecție trebuie să acopere complet nasul și gura persoanei care o poartă.
         </p>

         <div style="margin: 1.5em auto; text-align: center"><img src=${require("../images/pages/7_cumsefolosestamasca.jpg")} alt="Cum se folosește masca"></img></div>

         `,
      },
      {
        title: "Cum să cureți și să dezinfectezi",
        display_order: 4,
        slug: "sfaturi-pentru-dezinfectare",
        page: `
         <h3 id="sfaturi-pentru-dezinfectare">Sfaturi pentru dezinfectare</h3>
         <ul>
          <li>Curăță și dezinfectează frecvent suprafețele pe care le atingi cu dezinfectați pe bază de alcool sau clor. Acestea includ mese, clanțe, întrerupătoare de lumină, blaturi de bucătărie, mânere, birouri, telefoane, tastaturi, toalete, robinete și chiuvete.</li>
          <li>Dacă suprafețele sunt și murdare – folosește detergent sau săpun înainte de dezinfectare.</li>
         </ul>
         Opțiunile includ:
         <ul>
          <li><b>Diluarea înălbitorului (clorului) casnic.</b>
            <ul>
              <li>Pentru a face o soluție de înălbitor (clor), amestecă 5 linguri (80 ml) la 3,8 litri de apă sau 4 <strong>lingurițe</strong> la un litru de apă.</li>
              <li>Urmează instrucțiunile producătorului pentru aplicare și pentru ventilarea corespunzătoare a spațiilor după aplicare. Verifică data de expirare a produsului pentru a nu folosi produse expirate. Nu amesteca niciodată înălbitorul (clorul) cu amoniacul sau orice alt produs de curățare. Înălbitorul casnic care nu a expirat va fi eficient împotriva coronavirusurilor atunci când este diluat corespunzător.</li>
            </ul>
          </li>
          <li><b>Soluții alcoolice.</b>
           <ul>
              <li>Asigură-te că soluția de dezinfectat are cel puțin 70% alcool.</li>
            </ul>
          </li>
         </ul>
         <h3 id="cum-sa-cureti-si-sa-dezinfectezi-corect">Cum să cureți și să dezinfectezi corect</h3>
         <ul>
          <li>Poartă mănuși de unică folosință atunci când cureți și dezinfectezi suprafețele. Mănușile trebuie aruncate la gunoi după fiecare curățare pe care o efectuezi. Dacă se folosesc mănuși reutilizabile, acestea trebuie să fie dedicate curățării și dezinfectării suprafețelor pentru COVID-19 și nu trebuie utilizate în alte scopuri.</li>
          <li>Poartă mănuși de unică folosință atunci când manevrezi rufe murdare de la o persoană bolnavă și aruncă-le după fiecare utilizare. Dacă folosești mănuși reutilizabile, acestea trebuie să fie dedicate curățării și dezinfectării suprafețelor pentru COVID-19 și nu trebuie utilizate în alte scopuri. Spală-ți mâinile imediat după îndepărtarea mănușilor!</li>
          <li>Membrii gospodăriei trebuie să își curețe des mâinile, inclusiv imediat după îndepărtarea mănușilor și după contactul cu o persoană bolnavă, prin spălarea mâinilor cu apă și săpun timp de 20 de secunde. În cazul în care săpunul și apa nu sunt disponibile și mâinile nu sunt vizibil murdare, se poate folosi un dezinfectant de mâini pe bază de alcool, care conține cel puțin 70% alcool. Cu toate acestea, dacă mâinile sunt vizibil murdare, spălați prima dată mâinile cu apă și săpun.</li>
          <li>Membrii gospodăriei trebuie să urmeze acțiuni normale de prevenire a transmisiei viruslui la serviciu și acasă, inclusiv igiena mâinilor recomandată și evitarea atingerii ochilor, nasului sau gurii cu mâinile nespălate.</li>
          <li>Pe cât posibil, persoana bolnavă trebuie să mănânce / să fie hrănită în propria cameră. Articolele non-alimentare folosite în acest proces și care nu sunt de unică folosință trebuie manipulate cu mănuși și spălate cu apă caldă sau într-o mașină de spălat vase. Curăță-ți mâinile după manipularea acestor instrumente.</li>
          <li>Dacă este posibil, căptușește și dedică un coș de gunoi persoanei bolnave. Folosește mănuși atunci când arunci sacii de gunoi la tomberon. Spală-ți mâinile după manipularea sau aruncarea gunoiului.</li>
         </ul>
         <div style="background-color: #E5F9FE; padding: 10px;">
           <b>În plus, curățarea mâinilor mai trebuie realizată în următoarele momente:</b></br>
             <ul>
               <li>După ce îți sufli nasul, tușești sau strănuți.</li>
               <li>După utilizarea toaletei.</li>
               <li>Înainte de a mânca sau pregăti mâncarea.</li>
               <li>După contactul cu animale domestice sau animale de companie.</li>
               <li>Înainte și după ce acorzi îngrijiri de rutină unei alte persoane care are nevoie de asistență (de exemplu, un copil).</li>
             </ul>
         </div>
         `,
      },
      {
        title: "Cum să îți creezi un plan de acțiune la tine acasă",
        display_order: 5,
        slug: "plan-actiune-acasa",
        page: `
         <h3 id="plan-actiune">Ce poți face în această perioadă și cum să construiești un plan de acțiune</h3>
         <p>Discută cu oamenii care trebuie să fie incluși în planul tău de acțiune. Discută cu membrii gospodăriei, ce trebuie să faceți dacă va apărea un focar COVID-19 în propria comunitate.</p>
         <p>Evită întânirea cu rude și cu prieteni. De preferat ar fi întâlnirile on-line.</p>
         <p>Fă un plan pentru modalitățile de îngrijire a celor care ar putea avea un risc mai mare de complicații grave. Există informații limitate despre cine poate fi expus riscului de complicații severe cauzate de COVID-19. Din datele care sunt disponibile pentru pacienții cu COVID-19, precum și din datele pentru coronavirusuri asociate, cum ar fi SARS-CoV și MERS-CoV, este posibil ca vârstnicii și persoanele care au afecțiuni medicale cronice să fie expuși riscului de complicații severe. Nu intrați în contact direct sau indirect cu ei. Datele de la începutul acestei boli sugerează că persoanele în vârstă sunt mai susceptibile să aibă o formă mai gravă a COVID-19. </p>

         <p style="background-color: #E5F9FE; padding: 10px;">Dacă tu sau membrii propriei gospodării aveți un risc crescut de complicații cauzate de COVID-19, trebuie să consultați medicul de familie pentru mai multe informații despre monitorizarea stării de sănătate sub influența COVID-19. Organismele internaționale recomandă acțiuni care să ajute la protejarea persoanelor cu risc ridicat pentru complicații, în cazul apariției unui focar de COVID-19 în propria comunitate.</p>

         <p>Cunoaște-ți vecinii, vorbește cu ei despre planificarea de urgență la telefon sau on-line. Dacă propriul cartier are un site sau o pagină de socializare, ia în considerare urmărirea sau aderarea la acestea pentru a menține comunicare cu vecinii, accesul la informații și resurse.</p>
         <p>Identifică organizațiile de ajutor din propria comunitate. Creează o listă de organizații locale pe care le puteți contacta în cazul în care aveți nevoie de acces la informații, servicii de asistență medicală, ajutor și resurse. Ia în considerare organizațiile care furnizează servicii de sănătate mintală sau consiliere, mâncare și alte consumabile. vecinii, vorbește cu ei despre planificarea de urgență la telefon sau on-line. Dacă propriul cartier are un site sau o pagină de socializare, ia în considerare urmărirea sau aderarea la acestea pentru a menține comunicare cu vecinii, accesul la informații și resurse.</p>
         <p>Creează o listă de contacte de urgență. Asigură-te că există în propria casă o listă actuală de contacte de urgență pentru familie, prieteni, vecini, furnizori de servicii medicale, profesori, angajatori, departamentul local de sănătate publică și alte resurse ale comunității.</p>

         <p style="background-color: #ffd738; padding: 10px;">Nu luați medicamente antivirale sau antibiotice fără prescripție medicală!</p>

         <p>Rămâi în legătură cu ceilalți prin telefon, e-mail sau social media. Dacă locuiești singur și te îmbolnăvești în timpul extinderii unui focar de COVID-19, este posibil să ai nevoie de ajutor. Dacă ai o afecțiune medicală cronică și locuiești singur, roagă familia, prietenii și furnizorii de servicii medicale (medicul de familie sau Directia de Sanatate Publică din județul tău sau apelează TelVerde <a href="tel:0800800358">0800 800 358</a>) să te ia în evidență și să te verifice. Rămâi în legătură cu familia și prietenii cu afecțiuni medicale cronice.</p>
         <p>Ai grijă de sănătatea emoțională a membrilor gospodăriei tale. Răspândirea epidemiei poate genera situații stresante atât pentru adulți cat și pentru copii. Copiii răspund diferit la situații stresante comparativ cu adulții. Vorbește cu ei despre epidemie, încearcă să rămâi calm și asigură-i că sunt în siguranță. Descurajează copiii și adolescenții să se adune în locuri publice în timp ce cursurile de școală sunt suspendate, pentru a ajuta la încetinirea răspândirii COVID-19 în propria comunitate.</p>

        `,
      },
      {
        title:
          "15 recomandări privind conduita socială responsabilă în prevenirea răspândirii coronavirus",
        display_order: 6,
        slug: "recomandari-privind-conduita-sociala-responsabila",
        page: `
         <h3 id="recomandari">Protejați-vă, evitați contactul direct!</h3>
         <ul>
          <li> Evitați zonele aglomerate unde sunteți expuși la contact direct și/sau interacțiune cu un număr mare de persoane, de tipul adunărilor publice, cozi, zone de trafic intens, zone de recreere.</li>
          <li> Feriți copiii de acele locuri de joacă care presupun atingerea unor suprafețe/obiecte comune de către un număr mare de copii. </li>
          <li> Limitați la maximum orice contact direct cu alte persoane, în afara celor care fac parte din familia restrânsă, prin gesturi cum ar fi: strângerea mâinilor, îmbrățișările, sărutul obrajilor sau al mâinilor, atingerea fețelor cu mâinile. </li>
          <li> Se recomandă, inclusiv în privința persoanelor împreună cu care locuiți, să NU intrați în contact direct decât după igienizarea mâinilor atunci când reveniți la domiciliu. </li>
          <li> Evitați atingerea suprafețelor care sunt atinse în mod frecvent și de alte persoane, precum: balustrade, clanțe, mânere, butoane de lift sau de acces. În cazul în care sunteți totuși nevoiți să atingeți aceste suprafețe, protejați-vă folosind șervețele de unică folosință. </li>
          <li> Păstrați o distanță semnificativă, de 2 metri, față de celelalte persoane pe care le întâlniți. În cazul în care vă aflați în transportul în comun încercați să NU stați față în față cu alte persoane. </li>
          <li> Asigurați-vă, după folosirea transportului în comun, că v-ați igienizat mâinile înainte de a vă atinge fața, nasul sau gura.</li>
          <li> Folosiți, pe cât posibil, rute sau modalități alternative de transport pentru a evita zonele aglomerate de trafic de persoane. În cazul în care programul vă permite, folosiți intervalele orare cu nivel scăzut de trafic de persoane. </li>
          <li> Limitați la maximum orice contact direct cu alte persoane, în afara celor care fac parte din familia restrânsă, prin gesturi cum ar fi: strângerea mâinilor, îmbrățișările, sărutul obrajilor sau al mâinilor, atingerea fețelor cu mâinile. </li>
          <li> În zonele urbane, pentru distanțe mici, se recomandă folosirea modalităților alternative de deplasare, fie cu bicicleta/trotineta electrică, fie mersul pe jos. </li>
          <li> Limitați folosirea bancnotelor și a monedelor, optând pentru plăți cu cardul/telefonul sau plăți on-line. </li>
          <li> Transmiterea virușilor se realizează într-o pondere semnificativă prin intermediul banilor, cu care ia contact, statistic, un număr foarte mare de persoane. </li>
          <li> Optați pentru munca de acasă, în măsura în care aveți această posibilitate oferită de angajator. </li>
          <li> Există recomandări din partea Ministerului Muncii, în atenția angajatorilor, pentru flexibilizarea programului de lucru pentru angajați și prezentarea eventualelor opțiuni legale pe care le au la dispoziție. Guvernul a adoptat un nou cadrul legal. Mai multe <a target="_blank" href="http://www.mmuncii.ro/">detalii aici.</a> </li>
          <li> Respectați cu strictețe regulile de igienă personală recomandate de autorități, pentru a vă proteja atât pe dumneavoastră cât și pe cei apropiați. Folosiți masca de protecție pentru a-i proteja pe ceilalți.</li>
          <li> Spălați-vă pe mâini cu apă și săpun, minimum 20 de secunde, după orice contact cu o suprafață potențial contaminată.</li>
          <li> Folosiți prosoape de hârtie, de preferat, pentru a vă șterge mâinile.</li>
          <li> Nu vă atingeți ochii, nasul sau gura cu mâinile neigienizate</li>
          <li> Dacă strănutați sau tușiți acoperiți-vă gura și nasul cu un șervețel de unică folosință, pe care aveți grijă să-l aruncați imediat la coșul de gunoi.</li>
          <li> Dezinfectați frecvent, cu soluție pe bază de alcool sau clor, suprafețele cu care intrați în contact, atât acasă cât și la locul de muncă.</li>
          <li> Aerisiți de mai multe ori pe zi încăperile în care desfășurați activități.</li>
          <li> Luați medicamente antivirale sau antibiotice numai la prescripția medicului.</li>
          <li> NU beți lichide din aceeași sticlă/pahar cu alte persoane și nu folosiți aceleași tacâmuri.</li>
          <li> NU intrați în contact direct cu persoanele aflate în autoizolare la domiciliu, indiferent dacă prezintă sau nu simptome specifice coronavirus.</li>
          <li> Masca de protecție/masca chirurgicală îi protejează pe cei din jurul dumneavoastră, în cazul în care aveți simptome de gripă sau răceală, întrucât previne răspândirea virusului pe cale respiratorie.</li>
          <li> Masca de protecție trebuie să acopere complet nasul și gura persoanei care o poartă.</li>
          <li> Țineți cont de faptul că nu în toate cazurile infectarea cu noul coronavirus(COVID-19) este vizibilă prin simptome specifice (tuse, febră, dificultăți în respirație).</li>
          <li> Virusul poate fi răspândit inclusiv de persoane aparent sănătoase, care nu au cunoștință de faptul că sunt purtători ai noului coronavirus.</li>
          <li> Informați-vă despre noul coronavirus numai din surse oficiale!</li>
          <li> Puteți obține detalii dacă sunați la <b>0800.800.358</b>, care este un număr de informare, nu este un număr de urgență.</li>
          <li> Doar în cazul urgențelor sunați la 112!</li>
          <li> Evitați, cu prioritate, expunerea persoanelor în vârstă (peste 65 de ani) și a celor cu imunitate scăzută/boli asociate către alte persoane cu simptome de gripă sau răceală, în zone aglomerate sau zone cu trafic intens de persoane.</li>
          <li> Potrivit statisticilor, persoanele cele mai vulnerabile în cazul infectării cu noul coronavirus sunt vârstinicii cu multiple afecțiuni asociate (ex: diabet zaharat, boli pulmonare cronice, boli cardiovasculare, cancer).</li>
          <li> În Italia, cele mai multe decese sunt înregistrate la persoanele peste 63 de ani!</li>
          <li> Tinerii și copiii sunt mai puțin vulnerabili în cazul noului coronavirus, dar nu sunt pe deplin feriți de riscul îmbolnăvirii. Chiar și atunci când nu manifestă simptome specifice, ei pot transmite virusul celorlalte persoane fără să știe acest lucru.</li>
          <li> Semnalați autorităților orice caz despre care aveți cunoștință că ar fi putut intra în contact cu o persoană confirmată cu noul coronavirus sau ar fi venit dintr-o țară afectată (zona roșie sau zona galbenă) și care nu se află în izolare.</li>
          <li> Manifestați o atitudine preventivă față de orice caz, întrucât răspândirea virusului este posibilă și din partea persoanelor care nu manifestă simptome specifice.</li>
          <li> Semnalați imediat medicului de familie dacă ați călătorit în zonele afectate de coronavirus (COVID-19), chiar dacă la momentul respectiv NU se aflau pe lista zonelor aflate sub alertă. Detalii pot fi obținute accesând acest link, respectiv „Lista regiunilor și localităților din zona roșie și zona galbenă cu transmitere a COVID-19”, actualizată periodic.</li>
          <li> În cazul în care nu puteți contacta medicul de familie, apelați la Direcția de Sănătate Publică din județul dumneavoastră și în ultimă instanță la 112.</li>
          <li> Rămâneți acasă dacă aveți simptome de gripă sau răceală (tuse, febră, dificultăți în respirație) și sunați medicul de familie pentru a solicita sfaturi, NU mergeți din primul moment la unitățile de urgență.</li>
          <li> Există riscul, în cazul în care sunteți purtător al virusului, să transmiteți și altor persoane noul coronavirus.</li>
          <li> Este de preferat să rămâneți la domiciliu, iar transferul către spital să se realizeze în mod organizat, respectând toate măsurile de izolare.</li>
          </ul>
        `,
      },
    ],
    firstNodeId: null,
    form: null,
    buttons: null,
  },
  {
    title: "Ai simptome?",
    slug: "ai-simptome",
    doc_type: "STATIC_PAGE",
    doc_id: 103,
    active: false,
    showInTopMenu: false,
    showInSideMenu: false,
    display_order: 101,
    content: [
      {
        title: "Ai simptome?",
        display_order: 1,
        slug: "/",
        page: `
          <p>Simptomele de mai jos au fost raportate în cazul persoanelor confirmate cu infecția COVID-19, având intensitate diferită, de la cele ale unei simple răceli, până la stări grave care au condus la deces. Simptomele menționate mai jos se pot instala în cca. 2-14 zile de la data expunerii la virus:
          </p>
          <ul>
          <li>Febră. </li>
          <li>Tuse seacă. </li>
          <li>Insuficiență respiratorie (dificultate în respirare/senzație de sufocare)</li>
          </ul>
          <p>Unele persoane pot să fie infectate, dar nu dezvoltă niciun simptom și nu se simt bolnave. Majoritatea oamenilor (aproximativ 80%) își revin după ce au fost afectați de boală fără a avea nevoie de tratament special. Circa 1 din 6 persoane care au COVID-19 dezvoltă forme severe ale bolii și au dificultăți în respirație. Persoanele în vârstă și cei cu probleme medicale anterioare, precum tensiune arterială mare, probleme cu inima sau diabet au șanse mai mari să dezvolte o formă severă a bolii.
          </p>
          <p>Folosește chestionarul de mai jos pentru a identifica gradul de risc propriu pentru a putea vedea ce pași ai de urmat mai departe, în funcție de starea ta de sănătate și de acțiunile întreprinse în ultima perioadă.</p>
          `,
      },
    ],
    firstNodeId: 0,
    form: [
      {
        questionId: 1,
        questionText: "Ai peste 60 de ani?",
        type: "SINGLE_CHOICE",
        options: [
          {
            label: "Da",
            value: 1,
          },
          {
            label: "Nu",
            value: 0,
          },
        ],
      },
      {
        questionId: 2,
        questionText: "Care este sexul tău?",
        type: "SINGLE_CHOICE",
        options: [
          {
            label: "Masculin",
            value: 1,
          },
          {
            label: "Feminin",
            value: 2,
          },
        ],
      },
      {
        questionId: 3,
        questionText: "Ești fumător/fumătoare? (inclusiv țigări electronice)",
        type: "SINGLE_CHOICE",
        options: [
          {
            label: "Da",
            value: 1,
          },
          {
            label: "Nu",
            value: 0,
          },
        ],
      },
      {
        questionId: 4,
        questionText:
          "Ți-a spus vreun medic că ai o boală de inimă? (boală cardiovasculară inclusiv hipertensiune)?",
        type: "SINGLE_CHOICE",
        options: [
          {
            label: "Da",
            value: 1,
          },
          {
            label: "Nu",
            value: 0,
          },
        ],
      },
      {
        questionId: 5,
        questionText: "Ți-a spus vreun medic că ai diabet?",
        type: "SINGLE_CHOICE",
        options: [
          {
            label: "Da",
            value: 1,
          },
          {
            label: "Nu",
            value: 0,
          },
        ],
      },
      {
        questionId: 6,
        questionText:
          "Ți-a spus vreun medic că ai o boală a plămânilor? (pulmonară)?",
        type: "SINGLE_CHOICE",
        options: [
          {
            label: "Da",
            value: 1,
          },
          {
            label: "Nu",
            value: 0,
          },
        ],
      },
      {
        questionId: 7,
        questionText: "Ți-a spus vreun medic că ai cancer (boală oncologică)?",
        type: "SINGLE_CHOICE",
        options: [
          {
            label: "Da",
            value: 1,
          },
          {
            label: "Nu",
            value: 0,
          },
        ],
      },
      {
        questionId: 8,
        questionText: "Ți-a spus vreun medic că ai altă boală cronică?",
        type: "SINGLE_CHOICE",
        options: [
          {
            label: "Da",
            value: 1,
          },
          {
            label: "Nu",
            value: 0,
          },
        ],
      },
      {
        questionId: 10,
        questionText:
          "Ai avut în ultimele 14 zile febra 38 grade celsius sau mai mare?",
        type: "SINGLE_CHOICE",
        options: [
          {
            label: "Da",
            value: 1,
          },
          {
            label: "Nu",
            value: 0,
          },
        ],
      },
      {
        questionId: 11,
        questionText:
          "Ai avut în ultimele 14 zile durere în gât și/sau dificultate în a înghiți?",
        type: "SINGLE_CHOICE",
        options: [
          {
            label: "Da",
            value: 1,
          },
          {
            label: "Nu",
            value: 0,
          },
        ],
      },
      {
        questionId: 12,
        questionText: "Ai avut în ultimele 14 zile tuse intensă?",
        type: "SINGLE_CHOICE",
        options: [
          {
            label: "Da",
            value: 1,
          },
          {
            label: "Nu",
            value: 0,
          },
        ],
      },
      {
        questionId: 13,
        questionText: "Ai avut în ultimele 14 zile dificultate în a respira?",
        type: "SINGLE_CHOICE",
        options: [
          {
            label: "Da",
            value: 1,
          },
          {
            label: "Nu",
            value: 0,
          },
        ],
      },
      {
        questionId: 14,
        questionText: "Ți-a curs nasul în ultimele 14 zile?",
        type: "SINGLE_CHOICE",
        options: [
          {
            label: "Da",
            value: 1,
          },
          {
            label: "Nu",
            value: 0,
          },
        ],
      },
      {
        questionId: 15,
        questionText:
          "Ai călătorit în/prin zone în care au existat cazuri de noul coronavirus?",
        type: "SINGLE_CHOICE",
        options: [
          {
            label: "Da",
            value: 1,
          },
          {
            label: "Nu",
            value: 0,
          },
        ],
      },
      {
        questionId: 16,
        questionText:
          "Ai fost în contact direct cu o persoană diagnosticată/confirmată cu noul coronavirus?",
        type: "SINGLE_CHOICE",
        options: [
          {
            label: "Da",
            value: 1,
          },
          {
            label: "Nu",
            value: 0,
          },
        ],
      },
      {
        questionId: 17,
        questionText: "Ce ai de făcut",
        type: "FINAL",
        options: [
          {
            label:
              '<span>Înțelegem că există un grad de risc ridicat să fii infectat cu COVID-19. Haide să căutăm soluții împreună! 112 te va prelua cu prioritate și sigur există și alte persoane care vor putea fi alături de tine. Concentrează-te să dai datele cât mai clar și corect și să indici și numele unui membru din familie sau cunoscut care poate fi alături de tine în această perioadă. Limitează contactul fizic cu celelalte persoane, dar rămâi conectat cu ei prin telefon. Poți suna și la Direcția de Sănătate Publică din județul în care te afli. Păstrează-ți încrederea până când vei fi preluat de către medici! După ce ai intrat în îngrijirea medicilor, dar și înainte, ai posibilitatea să suni la Telverde pentru informații Covid 19 , <a href="tel:0800800358">0800 800 358</a> și/sau la Telverde pentru suport psihologic, <a href="tel:0800070030">0800 070 030</a>. Nu ești singur.</span>',
            value: 0,
          },
          {
            label:
              '<span>Infecția cu SARS-COV-2 (coronavirus) și răceala puternică au uneori simptome similare. Conform răspunsurilor tale, pentru siguranță te rugăm să suni la medicul de familie sau la TelVerde <a href="tel:0800800358">0800 800 358</a> și să aștepți ca cineva să te preia dacă vrei să te informezi în detaliu despre simptome si prevenție. Liniile sunt foarte ocupate acum, te rugăm să ai răbdare. Între timp, nu ieși din casă și limitează contactul cu familia pentru a nu îi pune în pericol și continuă să îți monitorizezi starea. Nu ești singur! Dacă simți ca emoțiile tale sunt mai greu de controlat până când vine rezultatul sau pur și simplu vrei să împărtășești starea ta, ai posibilitatea să suni și la Telverde pentru suport psihologic <a href="tel:0800070030">0800 070 030</a>.</span>',
            value: 1,
          },
          {
            label:
              '<span>Nu manifești niciun simptom de infecție. Îți recomandăm să rămâi în siguranță la domiciliu și să limitezi la maximum orice ieșire nerelevantă dacă ai posibilitatea și continuă să îți monitorizezi starea în fiecare zi. Dacă ai întrebări LEGATE de COVID 19 apelează la TelVerde <a href="tel:0800800358">0800 800 358</a> și așteaptă ca cineva să te preia. Liniile sunt foarte ocupate acum, te rugăm să ai răbdare. De asemenea, îți amintim că poți suna și la TelVerde <a href="tel:0800070030">0800 070 030</a> pentru suport psihologic și sprijin social!</span>',
            value: 2,
          },
          {
            label:
              '<span>Îți recomandăm să rămâi în siguranță la domiciliu și să limitezi la maximum orice ieșire nerelevantă dacă ai posibilitatea și continuă să îți monitorizezi starea în fiecare zi. Dacă ai întrebări LEGATE de COVID 19 apelează la TelVerde <a href="tel:0800800358">0800 800 358</a> și așteaptă ca cineva să te preia. Liniile sunt foarte ocupate acum, te rugăm să ai răbdare. De asemenea, îți amintim că poți suna și la TelVerde <a href="tel:0800070030">0800 070 030</a> pentru suport psihologic și sprijin social!</span>',
            value: 3,
          },
        ],
      },
    ],
  },
  {
    title: "Adaptare și rezistență",
    slug: "adaptare-si-rezistenta",
    doc_type: "STATIC_PAGE",
    doc_id: 104,
    active: false,
    display_order: 7,
    showInTopMenu: true,
    showInSideMenu: true,
    content: [
      {
        title: "Adaptare și rezistență",
        display_order: 1,
        slug: "/",
        page: `
        <p style="background-color: #ffd738; padding: 10px; font-weight: bold;">Epidemia de coronavirus 2019 (COVID-19) poate fi un motiv de stres pentru populație. Frica și anxietatea generate de o boală pot deveni copleșitoare și pot cauza emoții puternice în rândul adulților și copiilor</p>

        <p>Adaptarea la stres te face mai puternic pe tine, pe cei dragi și pe cei aparținând comunității tale. </p>
        <p>Fiecare răspunde diferit la situații de stres. Felul în care reacționezi în fața acestei epidemii poate depinde de experiențele anterioare, de lucrurile care te fac diferit de ceilalți și de comunitatea în care trăiești.  </p>

        <h3>Persoanele care pot avea reacții mai puternice la stres, în situații de criză, sunt:</h3>
         <ul>
          <li>Persoanele în vârstă și cele cu boli cronice, care prezintă un risc mai ridicat la îmbolnăvirea cu COVID-19</li>
          <li>Copiii și adulții</li>
          <li>Persoanele care ajută la tratarea COVID-19, spre exemplu doctorii și alte cadre din sistemul sanitar, ori cei care oferă prim ajutor</li>
          <li>Persoanele care suferă de o afecțiune mintală, inclusiv cele care au probleme legate de abuzul de substanțe cu risc de dependență</li>
        </ul>
        <h3>Stresul în timpul unei epidemii infecțioase poate include: </h3>
         <ul>
          <li>Frică și îngrijorare legate de propria sănătate și de sănătatea celor dragi</li>
          <li>Schimbări în rutina programului de somn și de alimentație</li>
          <li>Dificultatea de a dormi și de a te concentra</li>
          <li>Agravarea problemelor de sănătate cronice</li>
          <li>Abuzul de alcool, tutun sau alte tipuri de substanțe cu risc de dependență</li>
        </ul>
        <p>Persoanele cu afecțiuni legate de sănătatea mentală ar trebui să își continue tratamentul și să conștientizeze apariția unor simptome noi sau agravante. </p>
        <p>Acțiunile prin care îți manifești grija față de tine, prieteni și familie te pot ajuta să gestionezi stresul. Ajutându-i pe ceilalți să se adapteze condițiilor de stres poate duce la o comunitate mai puternică.</p>

        <div style="background-color: #E5F9FE; padding: 10px;">
        <b>Lucruri pe care le poți face pentru a te ajuta pe tine:</b></br>
        <ul>
          <li>Să iei pauze de la a urmări, citi sau asculta știri, inclusiv cele apărute în social media. Expunerea repetată la tema pandemiei poate deveni deranjantă.</li>
          <li>Să ai grijă de corpul tău. Încearcă să respiri adânc, să faci exerciții de stretching sau să meditezi. Încearcă să mănânci sănătos, să ai mese echilibrate, să faci mișcare în mod regulat, să dormi suficient și să eviți alcoolul sau substanțele ilegale. </li>
          <li>Fă-ți timp pentru a te deconecta. Încearcă activități care îți fac plăcere. </li>
          <li>Ia legătura cu ceilalți. Vorbește despre grijile tale sau despre felul în care te simți cu oamenii în care ai încredere.</li>
          <li>Sună-ți medicul de familie dacă stresul intervine în activitățile tale curente, mai multe zile la rând.</li>
        </ul>
        </div>
        `,
      },
      {
        title: "Sfaturi pentru părinți",
        display_order: 2,
        slug: "sfaturi-pentru-parinti",
        page: `
        <p style="background-color: #ffd738; padding: 10px;">Copiii și adolescenții reacționează, în mare parte, la ceea ce văd la adulții din jurul lor. Când părinții și îngrijitorii gestionează situația cu calm și încredere, dau dovadă de cel mai bun sprijin pentru copiii lor. Părinții pot oferi mai multă siguranță celor din jurul lor, în special copiilor, dacă sunt bine pregătiți. </p>

        <p>Nu toți copiii și adolescenții răspund la stres în același fel. Câteva din schimbările frecvente pe care le poți ține sub observație includ:</p>
        <ul>
          <li>Plâns excesiv sau comportamente care arată iritarea în rândul copiilor mici</li>
          <li>Întoarcerea la comportamente pe care le depășiseră (de exemplu, accidente în rutina legată de mersul la toaletă sau urinat în pat)</li>
          <li>Grijă excesivă sau tristețe</li>
          <li>Alimentație nesănătoasă sau deviații ale rutinei de somn</li>
          <li>Iritabilitate sau comportament rebel în rândul adolescenților</li>
          <li>Performanțe școlare slabe sau evitarea cursurilor</li>
          <li>Dificultate în a menține atenția sau concentrarea</li>
          <li>Evitarea activităților care le făceau plăcere în trecut</li>
          <li>Dureri inexplicabile de cap sau ale corpului</li>
          <li>Uz de alcool, tutun sau alte substanțe care pot provoca dependență</li>
        </ul>
        <p><b>Sunt multe lucruri pe care le poți face pentru a-ți susține copilul:</b></p>
        <ul>
          <li>Fă-ți timp pentru a discuta cu copilul tău despre epidemia COVID-19. Răspunde-i la întrebări și împărtășește-i informații <a href="https://www.stirioficiale.ro" target="_blank" rel="noopener noreferrer">despre COVID-19</a>, într-un mod pe care să-l poată înțelege copilul sau adolescentul.</li>
          <li>Asigură-ți copilul sau adolescentul că e în siguranță. Fă-l să conștientizeze că e ok dacă se simte supărat. Spune-i felul în care procedezi tu în momentele de stres, ca să poată să învețe de la tine cum să gestioneze situația.</li>
          <li>Limitează expunerea familiei tale la știri despre evenimente, inclusiv cele apărute pe social media. Copiii pot interpreta greșit ceea ce aud și pot fi speriați de lucruri pe care nu le înțeleg</li>
          <li>Încearcă să ții pasul cu ritualurile zilnice. Dacă școlile sunt închise, creează un program dedicat activităților de învățare, celor de relaxare sau de divertisment. </li>
          <li>Fii un model pentru ei. Ia pauze, încearcă să dormi suficient, să faci mișcare și să mănânci echilibrat. Ia legătura cu prietenii și cu membrii familiei. </li>
        </ul>
        `,
      },
      {
        title: "Ajutor pentru copii în gestionarea stărilor de urgență",
        display_order: 3,
        slug: "ajutor-pentru-copii",
        page: `
        <p>Indiferent de vârsta copilului tău, acesta se poate supăra sau poate avea emoții puternice în cadrul unei stări de urgență. Unii copii reacționează imediat, pe când alții afișează semne de dificultate mai târziu. Felul în care un copil reacționează și semnele normale ale suferinței pot varia în funcție de vârsta copilului, de experiențele anterioare și de felul în care copilul gestionează, în mod obișnuit, perioadele stresante.  </p>

        <p style="background-color: #ffd738; padding: 10px;">Copiii reacționează, în mare parte, la ceea ce văd la adulții din jurul lor. Când părinții și îngrijitorii gestionează situațiile de urgență într-un mod calm și încrezător, dau dovadă de cel mai bun sprijin pentru copiii lor. Părinții pot oferi mai multă siguranță celor din jurul lor, în special copiilor, dacă sunt bine pregătiți. </p>
        <p>Oamenii pot trece prin situații de stres dacă sunt expuși la imagini repetate ale unui dezastru discutat în mass media. În fazele incipiente, gândește-te la limitarea perioadei în care tu și cei dragi vă expuneți acestor mediatizări.</p>

        <h3>Ce poți face pentru a-i ajuta pe copii să gestioneze o situație de urgență</h3>

        <p>Este esențial ca părinții și îngrijitorii să dea un exemplu pozitiv, gestionând stresul prin alegeri sănătoase: să mănânce echilibrat, să facă mișcare, să doarmă suficient și să evite consumul de alcool sau de substanțe care pot da dependență. Când ești pregătit, odihnit și relaxat, poți reacționa mai bine la evenimente neașteptate și poți lua cele mai bune decizii pentru familia ta și pentru cei dragi. </p>
        <p>Următoarele sfaturi te pot ajuta să reduci stresul înainte, în timpul și după un dezastru sau eveniment traumatizant.</p>

        <h4>Înainte</h4>
        <ul>
          <li>Discută cu copiii tăi, astfel încât să știe că ești pregătit să le creezi un mediu în care să se simtă în siguranță.</li>
          <li>Revizuiește planurile de siguranță înainte ca dezastrul sau urgența să se întâmple. Când ai un plan, încrederea copiilor crește și îi ajută să le ofere un sentiment de control. </li>
        </ul>

        <h4>În timpul</h4>
        <ul>
          <li>Păstrează-ți calmul și liniștește-i pe cei mici.</li>
          <li>Discută cu copiii despre lucrurile care se întâmplă, într-un mod în care pot înțelege. Încearcă să le explici în termeni simpli, potriviți pentru vârsta lor. </li>
        </ul>
        <h4>După</h4>
        <ul>
          <li>Creează-le copiilor contexte în care să vorbească despre ceea ce tocmai s-a întâmplat și felul în care gândesc. Încurajează-i să îți spună ce îi îngrijorează și pune-le întrebări.</li>
          <li>Poți să-ți ajuți copiii să simtă că sunt în control și că își pot gestiona emoțiile încurajându-i să se implice în activități direct legate de dezastru. De exemplu, copiii pot să se ajute unul pe celălalt după o situație de urgență, prin acțiuni de voluntariat care ajută comunitatea și membrii familiei, într-un cadru care să le ofere siguranță. Copiii NU ar trebui să participe la acțiuni de curățare de după un dezastru, din motive de sănătate și de siguranță. </li>
          <li>Este dificil să prezici modul în care unii copiii vor reacționa la dezastre sau la evenimente traumatizante. Pentru că părinții, profesorii și alți adulți cunosc comportamentul copilului în diferite situații, e important ca aceștia să lucreze împreună și să împărtășească informații despre cum reușește fiecare copil să depășească un eveniment traumatizant. </li>
        </ul>

        `,
      },
      {
        title: "Reacții obișnuite pentru copii și adolescenți",
        display_order: 4,
        slug: "reactii-obisnuite",
        page: `
        <p>Reacțiile obișnuite, ca urmare a situațiilor de stres, se vor diminua cu timpul, în cazul majorității copiilor. Copiii care au fost direct expuși la dezastre pot trece, din nou, prin stări de supărare; pot reveni comportamente legate de eveniment, dacă aceștia văd sau aud lucruri care să le reamintească de ceea ce s-a întâmplat. Dacă cei mici continuă să fie foarte afectați sau dacă reacțiile lor periclitează activitatea școlară ori relațiile cu ceilalți, părinții sunt sfătuiți să se adreseze unui specialist sau să discute cu cineva care are competențe în gestionarea nevoilor emoționale ale copiilor. Învață mai multe despre reacțiile obișnuite în condiții de stres:</p>

        <h4>Pentru bebeluși și copii de până la 2 ani</h4>
        <p>Bebelușii pot deveni mai irascibili. S-ar putea să plângă mai des ca în mod obișnuit sau să vrea să fie ținuți în brațe mai mult. </p>

        <h4>Pentru copii cu vârste cuprinse între 3 și 6 ani</h4>
        <p>Preșcolarii și copiii de grădiniță s-ar putea întoarce la comportamente pe care le depășiseră deja. De exemplu, accidente în rutina legată de mersul la toaletă, urinat în pat sau stări de spaimă asociate separării de părinți sau de îngrijitori. E posibil să aibă accese de furie sau dificultăți în a dormi. </p>

        <h4>Pentru copii cu vârste cuprinse între 7 și 10 ani</h4>
        <p>Copiii mai mari pot resimți supărare, furie sau teama de repetare a evenimentului. Colegii lor pot transmite informații false; cu toate acestea, părinții sau îngrijitorii pot corecta dezinformările. Copiii mai mari se concentrează pe detaliile evenimentului și fie vor să vorbească despre asta tot timpul, fie refuză total să vorbească. Există posibilitatea ca aceștia să întâmpine dificultăți în menținerea concentrării.</p>

        <h4>Pentru pre-adolescenți și adolescenți </h4>
        <p>Unii pre-adolescenți și adolescenți răspund la traume prin izbucniri. De exemplu, pot ajunge să se comporte neglijent sau să apeleze la alcool sau la substanțe care pot da dependență. Alții se pot teme să iasă din casă. Unii ar putea să reducă timpul petrecut cu prietenii lor. S-ar putea lăsa copleșiți de emoții intense, simțind că nu sunt în stare să vorbească despre ele. Emoțiile pot să-i facă să devină mai iritați și chiar să ajungă să se certe cu frații, părinții, îngrijitorii sau alți adulți. </p>

        <div style="background-color: #ffd738; padding: 10px;">
          <h4>Pentru copii cu nevoi speciale</h4>
          Copiii care au nevoie permanentă de aparate care să le susțină sistemul respirator sau cei care sunt imobilizați într-un scaun cu rotile sau la pat, pot avea reacții mai puternice în fața unui dezastru iminent sau în desfășurare. Ar putea să resimtă mai intens momentele de stres, îngrijorare sau furie, în comparație cu ceilalți copii, pentru că au mai puțin control asupra stării lor generale. Același lucru este valabil pentru copii cu alte tipuri de limitări de natură fizică, emoțională sau intelectuală. Copiii cu nevoi speciale pot avea nevoie de încurajări suplimentare, de mai multe explicații legate de eveniment, de mai mult confort și de alte forme de contact fizic, precum îmbrățișări din partea celor dragi.
        </div>

        `,
      },
      {
        title: "Pentru cei care tocmai au ieșit din carantină",
        display_order: 5,
        slug: "cei-care-tocmai-au-iesit-din-carantina",
        page: `
        <p>Separarea de ceilalți, dacă un cadru medical consideră că ai fi putut fi expus la COVID-19, poate fi o situație de stres, chiar dacă nu te îmbolnăvești. Fiecare se simte diferit după perioada de stat în carantină. O parte din stări includ:</p>
        <ul>
          <li>Emoții contradictorii, inclusiv cel de destindere de după perioada carantinei</li>
          <li>Teamă și îngrijorare legată de propria sănătate și de sănătatea celor dragi</li>
          <li>Stresul cauzat de experiența auto-monitorizării sau a monitorizării celorlalți, pentru depistarea semnelor sau simptomelor specifice COVID-19</li>
          <li>Tristețe, furie sau frustrare, ca urmare a temerilor nefondate de contactare a bolii, din partea prietenilor sau a celor dragi, în ciuda faptului că ai fost declarat necontagios</li>
          <li>Vina asociată faptului că nu ai putut să lucrezi sau să ai grijă de copii, în parametri normali, pe durata carantinei</li>
          <li>Alte schimbări emoționale sau legate de sănătatea mintală</li>
          <li>Copiii mai pot simți supărare emoții puternice dacă ei sau cineva cunoscut a ieșit din carantină.</li>
        </ul>

        `,
      },
      {
        title: "Diminuarea stigmatului",
        display_order: 6,
        slug: "diminuarea-stigmatului",
        page: `
        <p style="background-color: #ffd738; padding: 10px; font-weight: bold;">Urgențele legate de sănătate publică, așa cum e epidemia de coronavirus 2019 (COVID-19), reprezintă momente stresante pentru toți oamenii și toate comunitățile. Frica și anxietatea legate de o pandemie pot conduce la un stigmat social vizavi de oameni, locuri sau lucruri.</p>
        <p>De exemplu, stigmatizarea și discriminarea pot avea loc atunci când oamenii asociază o epidemie, cum e COVID-19, cu o populație sau o naționalitate, chiar dacă nu toți indivizii din respectiva țară sau regiune se află în situații de risc pentru boală. Stigmatizarea mai poate fi întâlnită când o persoană tocmai a ieșit din carantina COVID-19, chiar dacă ea nu mai este considerată un factor de risc în răspândirea virusului către ceilalți. </p>
        <p>Este important să ne amintim că oamenii – inclusiv cei cu descendență asiatică – care nu locuiesc sau care nu au fost recent într-o zonă de răspândire a virusului care duce la COVID-19, ori cei care nu au fost în contact cu o persoană confirmată sau suspectă de COVID-19, nu prezintă un risc mai ridicat de răspândire a virusului COVID-19 decât indivizii din alte țări.</p>

        <h3>Câteva din grupurile care pot suferi în urma stigmatizării din cauza COVID-19 includ:</h3>
        <ul>
          <li>Persoane cu descendență asiatică</li>
          <li>Cei care au călătorit</li>
          <li>Cetățeni din diaspora</li>
          <li>Forțele de intervenție sau personalul din sistemul medical</li>
        </ul>
        <p>Stigmatizarea îi afectează pe toți pentru că generează teamă sau furie față de alți oameni. </p>

        <h3>Grupurile stigmatizate pot fi supuse unor experiențe precum:</h3>
        <ul>
          <li>Evitare socială sau respingere</li>
          <li>Refuzul accesului la servicii de sănătate, de educație, locative sau de angajare</li>
          <li>Violență fizică</li>
        </ul>
        <p>Stigmatizarea afectează sănătatea emoțională sau mintală a grupurilor în cauză și a comunităților în care trăiesc. Oprirea stigmatului este importantă pentru rezistența comunităților și a membrilor săi. </p>
        <p>Fiecare poate ajuta la stoparea stigmatizării din jurul COVID-19 cunoscând faptele și transmițându-le celorlalți membrii ai comunității. </p>
        <p>Specialiștii în comunicare și oficialii din sistemul de sănătate publică pot contracara stigmatizarea prin modul în care răspund la COVID-19.</p>
        <ul>
          <li>Păstrarea datelor de natură personală și a confidențialității celor care caută ajutor medical și al celor care ar putea face parte dintr-o investigație referitoare la contactele unui caz.</li>
          <li>Comunicarea rapidă a riscului sau a lipsei de risc asociat cu anumite produse, oameni sau locuri.</li>
          <li>Acțiuni de conștientizare publică despre COVID-19, fără a crește temerile din rândul populației.</li>
          <li>Transmiterea de informații corecte despre evoluția virusului.</li>
          <li>Luarea de atitudine împotriva comportamentelor negative, incluzând afirmațiile negative din social media despre anumite grupuri de oameni. </li>
          <li>Să fie prudenți în transmiterea anumitor imagini. Să se asigure că nu răspândesc stereotipuri. </li>
          <li>Relaționarea cu grupuri stigmatizate, prin interacțiuni personale și prin intermediul canalelor media, inclusiv cele de știri și de social media.</li>
          <li>Să mulțumească angajaților din sistemul de sănătate și celor care răspund apelurilor. Cei care au călătorit în zone de largă răspândire a COVID-19, pentru a ajuta, au avut o contribuție valoroasă pentru toată lumea, asigurându-se că boala nu se răspândește și mai mult. </li>
          <li>Să împărtășească nevoia de sprijin social pentru cei care s-au întors din China sau care sunt îngrijorați cu privire la prietenii sau la rudele rămase în zonele afectate. </li>
        </ul>

      `,
      }
    ],
    buttons: null,
    firstNodeId: 0,
    form: null,
  },
  {
    title: "Pentru cei care oferă ajutor",
    slug: "pentru-cei-care-ofera-ajutor",
    doc_type: "STATIC_PAGE",
    doc_id: 105,
    active: false,
    display_order: 8,
    showInTopMenu: false,
    showInSideMenu: true,
    content: [
      {
        title: "Pentru cei care oferă ajutor",
        display_order: 1,
        slug: "/",
        page: `
        <p style="background-color: #ffd738; padding: 10px; font-weight: bold;">Cei care fac parte din forțele de răspuns (instituții și voluntari deopotrivă) în situații de urgență vor fi expusi la stres in perioada urmatoare. Gestionarea stresului și luarea pauzelor vor face intervenția ta mai bună.</p>
        <p>Implicarea ta în gestionarea crizei asociate cu COVID-19 te poate afecta din punct de vedere emoțional. Există acțiuni pe care le poți face pentru a te ajuta să reduci reacțiile de stres traumatic secundar (STS), asociate cu gestionarea evenimentelor de criză.</p>
        <ul>
          <li>Recunoaște faptul că STS poate afecta pe oricine care ajută alte persoane într-un eveniment traumatic.</li>
          <li>Învață care sunt simptomele, inclusiv cele fizice (oboseală, boală) și psihice (frică, sevraj, vinovăție) pentru a le putea recunoaște mai ușor.</li>
          <li>Acordă timp, atât ție cât și familiei tale pentru a vă recupera după ce ai făcut parte din forțele de răspuns la pandemie.</li>
          <li>Creează-ți un program cu activități de îngrijire personală de care te bucuri, precum să petreci timp cu prietenii și familia, să faci exerciții fizice sau să citești o carte.</li>
          <li>Ia o pauză de la știrile sau relatările legate de COVID-19</li>
          <li>Cere ajutor dacă te simți copleșit sau îngrijorat de faptul că COVID-19 îți afectează capacitatea de a avea grijă de familia și pacienții tăi, așa cum o făceai înainte de răspândirea virusului.</li>
         </ul>

         <div style="margin: 1.5em auto; text-align: center"><img src=${require("../images/pages/covid_ro_ceicareneoferajutor.svg")} width="80%" alt="Cei care ne oferă ajutor"></img></div>

         <h4>Semne că suferi de epuizare profesională (Burnout):</h4>
         <ul>
          <li>Tristețe, depresie sau apatie </li>
          <li>Sentimente de frustrare, care apar cu ușurință</li>
          <li>Reacții de apărare - dai vina pe alții, iritabilitate</li>
          <li>Lipsa emoțiilor, indiferență</li>
          <li>Detașament - Izolare sau deconectare de ceilalți</li>
          <li>Neglijarea igienei personale</li>
          <li>Senzație constantă de oboseală, epuizare (secare de energie) sau de copleșire</li>
          <li>Poți să ai senzația:
            <ul>
              <li>De eșec</li>
              <li>Că nimic din ceea ce faci nu mai ajută, nu mai are sens</li>
              <li>Că nu îți faci treaba bine</li>
              <li>Că ai nevoie de alcool/alte substanțe pentru a face față</li>
            </ul>
          </li>
         </ul>

         <div style="background-color: #E5F9FE; padding: 10px;">
         <h4>Semne de Stres Traumatic Secundar (STS)</h4>
         <ul>
          <li>Teama sau frica excesivă că ceva rău se va întâmpla</li>
          <li>Ușor de speriat sau „în gardă” tot timpul</li>
          <li>Semne fizice de stres (de exemplu senzația că inima îți bate cu putere)</li>
          <li>Coșmaruri sau ganduri recurente legate de situații traumatice </li>
          <li>Sentimentul că traumele celorlalți sunt ale tale</li>
         </ul>
         <p>Limitează timpul pe care îl petreci lucrând singur și încearcă să te implici mai mult, fie și în mediul online în activități de echipă, atunci când este posibil. </p>
         </div>

         <h3>Obține sprijin din partea membrilor echipei: dezvoltă un sistem de tip „buddy system/camarad”</h3>
         <p>Într-un sistem de tip „buddy system/camarad”, doi membri ai forțelor de răspuns formează o echipă pentru a se sprijini reciproc, pentru a-și monitoriza unul altuia nivelul de stres și de siguranță, cât și volumul de muncă.</p>
         <ul>
          <li><strong>Cunoașteți-vă.</strong> Vorbiți despre trecutul fiecăruia, interese, hobby-uri și familie. Identificați-vă reciproc punctele forte și slăbiciunile. </li>
          <li><strong>Fiți atenți unul la celălalt.</strong> Dacă se poate, încercați să lucrați în aceeeșii locație. </li>
          <li><strong>Setați ore când veți intra în contact</strong> unul cu celălalt. Ascultați cu atenție și împărtășiți experiențe și sentimente. Încercați să acceptați situațiile dificile și marcați realizările/ micile succese, chiar și pe cele mai mici. </li>
          <li><strong>Oferiți-vă ajutorul pentru nevoile de bază</strong> Vorbiți despre trecutul fiecăruia, interese, hobby-uri și familie. Identificați-vă reciproc punctele forte și slăbiciunile. </li>
          <li><strong>Monitorizați-vă reciproc sarcinile de lucru</strong> Încurajați-vă unul pe celălalt să luați pauze. Discutați despre moduri prin care puteți reduce  stresul (odihnă, rutina de somn, experciții fizice și respirații profunde). </li>
          <li><strong>Încearcă să creezi un mediu în echipă,</strong> în care colegul tău să se simtă în siguranță să își exprime nevoile și limitele. Facilitează comunicarea lui cu liderii echipei sau ceilalți colegi. </li>
         </ul>
         <h3>Tehnici de îngrijire personală pentru membrii echipelor de intervenție</h3>
         <ul>
          <li>Limitează-ți orele la muncă la ture care nu depășesc 12 ore.</li>
          <li>Lucrează în echipe și limitează timpul pe care îl petreci lucrând individual.</li>
          <li>Încearcă să ții un jurnal.</li>
          <li>Vorbește cu familia, prietenii, șefii și colegii despre sentimentele și trăirile tale.</li>
          <li>Exersează tehnici de respirație și relaxare.</li>
          <li>Menține o dietă sănătoasă și asigură-te că ai un program adecvat de somn și exerciții fizice.</li>
          <li>Acceptă că este perfect normal să-ți setezi limite și să spui „nu”.</li>
          <li>Evită sau limitează pe cât posibil cofeina și consumul de alcool.</li>
         </ul>

         <div style="background-color: #E5F9FE; padding: 10px;">
         <h3>Este important să îți reamintești:</h3>
         <ul>
          <li>Nu ești egoist dacă iei pauze.</li>
          <li>Nevoile supraviețuitorilor nu sunt mai importante decât bunăstarea sau propriile tale nevoi.</li>
          <li>Să lucrezi tot timpul nu înseamnă că vei avea cea mai bună contribuție.</li>
          <li>Există și alte persoane care pot ajuta în răspunsul la pandemie.</li>
         </ul>
         <p>A fi parte din forțele de răspuns în caz de dezastre poate fi o activitate care îți aduce satisfacții însă este în acelați timp și  și stresantă. Recunoscând că ești stresat și încercând să găsești metode de a gestiona  stresul în timp ce continui să răspunzi solicitărilor, te va ajuta să te menții sănătos și astfel poți continu să îi ajuți pe cei care sunt afectați.</p>
         </div>

         <p>&nbsp;</p>

         <p style="background-color: #ffd738; padding: 10px; font-weight: bold;">
         Fundația Estuar a lansat 4medicALL, o linie de consiliere și suport psihologic oferită de specialiști în sănătate mintală pentru cei mai încercați dintre noi în această perioadă, personalul medical, paramedical și sanitar implicat în tratarea persoanelor infectate cu virusul COVID-19, linia I de intervenție.
         </br></br>
         Cum puteți beneficia de ajutor:
         </br><a href="tel:+40758119314">0758 119 314</a>
         </br><a href="tel:+40758119313">0758 119 313</a>
         </br><a href="tel:+40758119304">0758 119 304</a>
         </br></br>
         <a href="mailto:consiliere@estuar.org">consiliere@estuar.org</a>
         </p>

       `,
      },
    ],
    form: null,
    firstNodeId: null,
    buttons: null,
  },
  {
    title: "Întrebări frecvente - COVID-19",
    slug: "intrebari-frecvente-covid19",
    doc_type: "STATIC_PAGE",
    doc_id: 106,
    active: false,
    display_order: 9,
    showInTopMenu: false,
    showInSideMenu: true,
    content: [
      {
        title: "Întrebări frecvente - COVID-19",
        display_order: 1,
        page: `<p>Întrebări frecvente despre COVID-19</p>`,
      },
    ],
    firstNodeId: null,
    form: null,
    buttons: null,
    accordion: [
      {
        title: `Ce este noul coronavirus?`,
        content: `
            <p>Noul coronavirus care provoacă COVID-19 este o nouă infecție virală din categoria coronavirusurilor, care nu era identificată anterior. Virusul care cauzează infecția cu COVID-19 nu este același cu coronavirusurile care circulă în mod comun în populație (Coronavirusurile comunitare), care cauzează boli ușoare ca răceala.</p>
            <p>Un diagnostic cu coronavirus comunitari (229E, NL63 sau HKU1) nu este același lucru cu un diagnostic cu COVID-19. Pacienții cu COVID-19 vor fi evaluați și tratați diferit decât cei cu coronavirusuri comunitare.</p>
        `,
      },
      {
        title: `De ce este boala numită “Coronavirus Disease 2019”, COVID-19?`,
        content: `
            <p>Pe data de 11 Februarie 2019, Organizația Mondială a Sănătății a anunțat un nume oficial pentru boala virală care cauzează epidemia de coronavirus nou din 2019, identificat prima dată în orașul Wuhan din China. Noul nume al bolii este “Coronavirus disease 2019 - care se traduce “boală coronavirus 2019”- abreviată COVID-19. În COVID ‘CO’ vine de la corona, ‘VI’ vine de la virus și ‘D’ de la disease (boală). Înainte, boala era numită “noul coronavirus - 2019” sau “2019-nCoV”.</p>
            <p>Există mai multe tipuri de coronavirusuri umane, inclusiv unele care cauzează în mod curent infecții ușoare ale tractului respirator superior. COVID-19 e o boală nouă, cauzată de un coronavirus nou, care nu a fost descoperit anterior la oameni. Numele a fost selectat folosind Ghidul OMS (Organizația Mondială a Sănătății) de bune practici pentru numirea noilor boli infecțioase umane.</p>
        `,
      },
      {
        title: `De ce ar dori cineva să dea vina pe/ sau să evite anumiți indivizi și anumite grupuri din cauza epidemiei?`,
        content: `
            <p>Cetățeni din România ar putea fi îngrijorați sau anxioși despre prieteni și rude care locuiesc în, se întorc din, sau vizitează zone afectate puternic de COVID-19. Unii oameni sunt îngrijorați de răspândirea bolii. Frica și anxietatea pot duce la stigmă socială, de exemplu față de persoane din China sau Italia sau față de persoane care au fost în carantină sau izolare.</p>
            <p>Stigmatizarea e discriminarea unui grup de oameni, un loc sau o națiune. Stigma e asociată cu o lipsă de cunoștințe despre COVID-19 și felurile în care se răspândește, cu o nevoie de a găsi pe cineva vinovat, cu frica de îmbolnăvire și moarte sau cu știri false care împrăștie mituri și zvonuri.</p>
            <p>Stigma afectează pe toată lumea deoarece creează mai multă frică sau furie față de oameni obișnuiți care ajung să fie învinuiți în locul bolii care cauzează problema.</p>
        `,
      },
      {
        title: `Cum putem opri stigma asociată COVID-19?`,
        content: `
            <p>Putem lupta împotriva stigmatizării și să îi ajutăm pe ceilalți, nu să îi rănim, oferind suport social. Trebuie să ne opunem stigmatizării prin stăpânirea bună a datelor exacte. Comunicând strict cunoștințe legate de virus, cum se  răspândește și despre efectele acestuia fără a învinovăți categorii largi de persoane pe bază de rasă, etnicitate sau proveniență, putem să oprim stigmatizarea.</p>
        `,
      },
      {
        title: `Ar trebui să fiu îngrijorat(ă) de COVID-19?`,
        content: `
            <p>Îmbolnăvirile datorită infecției cu noul coronavirus sunt în general ușoare, în special în rândul copiilor și al tinerilor adulți. Cu toate acestea, COVID-19 poate cauza îmbolnăviri serioase: aproximativ 1 din 5 persoane care contactează această boală au nevoie de îngrijiri medicale spitalicești. Este așadar normal ca oamenii să se îngrijoreze de cum îi va afecta epidemia COVID-19 pe ei și pe cei dragi.</p>
            <p>Ne concentrăm îngrijorările în acțiuni pentru a ne proteja pe noi, pe cei dragi și comunitatea în care trăim. Prima dintre aceste acțiuni este spălarea frecventă și riguroasă a mâinilor cât și menținerea unei igiene respiratorii bune. În același timp, informați-vă și urmați recomandările autorităților locale și naționale privind orice restricții de călătorie, mobilitate și izolare.</p>
        `,
      },
      {
        title: `Care e sursa virusului?`,
        content: `
            <p>Coronavirusurile sunt o familie virală numeroasă. Unele pot cauza boli la om pe când altele, precum coronavirusurile canine sau feline infectează doar animalele. Rareori unele coronavirusuri care infectează animalele au făcut tranziția la om, putând fi transmise de către acesta. Asta se suspectează că s-a întâmplat în cazul virusului care cauzează COVID-19. Sindromul Respirator din Orientul Mijlociu (MERS) și Sindromul Respirator Sever Acut (SARS) sunt alte două exemple de coronavirusuri care au trecut de la animal la om.</p>
        `,
      },
      {
        title: `Cum se răspândește virusul?`,
        content: `
            <p>Virusul a fost detectat pentru prima dată în orașul Wuhan, provincia Hubei, China. Primele infecții au fost conectate, în urma anchetei epidemiologice, de o piață de animale vii. Însă acum virusul se răspândește de la om la om. E important să ținem cont de faptul că răspândirea de la om la om poate continua fără gazde animale.</p>
            <p>Unele virusuri sunt extrem de contagioase (precum pojarul) iar altele mai puțin.Virusul care cauzează COVID-19 pare să fie unul care se răspândește ușor și în mod susținut în comunități (“răspândire comunitară”) în unele zone geografice afectate. Răspândirea comunitară înseamnă că populația dintr-o zona a fost infectată cu virusul, inclusiv un număr de persoane despre care nu se știe unde au contactat boala (nu se cunoaște originea bolii).</p>
        `,
      },
      {
        title: `Poate cineva care are COVID-19 să răspândească boala?`,
        content: `
            <p>Virusul care cauzează COVID-19 se răspândește de la om la om. Cineva care este bolnav cu COVID-19 poate răspândi boala către alții. De aceea se recomandă carantinarea pacienților până sunt din nou sănătoși și nu mai prezintă risc de infecție pentru alții.</p>
            <p>Se crede că virusul se răspândește mai ales de la persoană la persoană în mod direct:</p>
            <ul>
                <li>Între persoane care se află în contact direct (sub 1,5 m)</li>
                <li>Prin picături respiratorii produse de o persoană infectată care strănută sau care tușește.</li>
            </ul>
            <p>Aceste picături microscopice pot ajunge în gura sau nasul persoanelor aflate în apropiere sau pot fi inhalate direct în plămâni.</p>
        `,
      },
      {
        title: `Poate cineva care nu pare bolnav să răspândească virusul?`,
        content: `
            <p>Se crede că persoanele sunt contagioase mai ales atunci când sunt simptomatice (vizibil bolnave). Este însă posibil ca unele persoane să răspândească virusul înainte sau fără să manifeste simptome; există cazuri în care se pare că acest lucru s-a întâmplat cu noul coronavirus dar aceasta nu pare să fie principala modalitate de răspândire.</p>
        `,
      },
      {
        title: `Pot lua virusul de pe o suprafață sau un obiect contaminat?`,
        content: `
            <p>Este posibil ca o persoană să se îmbolnăvească de COVID-19 prin atingerea unei suprafețe sau al unui obiect care are virusul pe el, apoi atingându-și gura, nasul sau ochii, dar aceasta nu pare să fie principala modalitate de răspândire.</p>
        `,
      },
      {
        title: `Cât timp poate supraviețui noul coronavirus pe suprafețe contaminate? `,
        content: `
            <p>Deși încă nu este sigur cât timp supraviețui virusul care cauzează COVID-19 pe suprafețe, Organizația Mondială a Sănătății sugerează că acesta pare să se comporte ca și celălalte tipuri de coronavirus. Studiile făcute pe acestea sugerează că pot persista pe suprafețe între câteva ore și câteva zile (informație susținută și de datele preliminare despre noul coronavirus). Acest timp poate varia în funcție de condiții (ex. tipul de suprafață, temperatura sau umiditatea din mediu). </p>
            <p>Dacă considerați că o suprafață ar putea fi infectată, curățați-o cu un dezinfectant pentru a omorâ virusul și pentru a vă proteja pe dumneavoastră și pe cei din jur. Curățați-vă apoi mainile cu o soluție pe bază de alcool sau spălați-vă pe mâini cu apă și săpun. Evitați să vă atingeți ochii, nasul și gura.</p>
        `,
      },
      {
        title: `Care este durata de infecție cu COVID-19?`,
        content: `
            <p>Cât de multă vreme o persoană e bolnavă în mod activ variază de la om la om și la fel poate varia decizia de a elibera pe cineva din spital, carantină sau izolare. Eliberarea se face de la caz la caz în funcție de decizia personalului medical și al specialiștilor în prevenția răspândirii bolilor infecțioase. Decizia se ia pe baza simptomatologiei și testelor de laborator.</p>
            <p>Directivele Centrului de Control și Prevenția al Bolilor (CDC) din SUA subliniază trei criterii pentru eliberarea din carantină:</p>
            <ul>
                <li>Pacientul nu are febră (fără a fi folosit medicamente ce reduc febra)</li>
                <li>Pacientul nu are tuse sau alte simptome fizice</li>
                <li>Pacientul a ieșit negativ la cel puțin două teste de exudat faringian consecutive, luate la distanță de 24 de ore.</li>
            </ul>
            <p>O persoană eliberată din izolare e considerată ca fiind necontagioasă, neprezentând risc de infecție pentru alții.</p>
        `,
      },
      {
        title: `Poate o persoană care a fost în carantină să îi infecteze pe alții?`,
        content: `
            <p>Carantină înseamnă separarea unei persoane sau a unui grup de persoane care a fost expus unei boli contagioase (dar nu a dezvoltat simptome de boală) de populația care nu a fost expusă, pentru a limita posibilitățile de răspândire ale bolii. La fel ca autoizolarea, carantina este de obicei stabilită pentru perioada de incubație a bolii comunicabile, adică durata de timp în care oamenii dezvoltă boala după expunere. Pentru COVID-19, perioada de carantinare e de 14 zile de la data expunerii, deoarece 14 zile este cea mai lungă perioadă de incubație descoperită la coronavirusuri similare. O persoană eliberată din carantină e considerată ca fiind necontagioasă, neprezentând risc de infecție pentru alții.</p>
        `,
      },
      {
        title: `Poate virusul care cauzează COVID-19 să fie răspândit  prin mâncare, inclusiv mâncare congelată sau refrigerată?`,
        content: `
            <p>De regulă coronavirusurile se răspândesc de la persoană la persoană prin picături respiratorii. În prezent nu există dovezi care să susțină transmisia CIVID-19 prin mâncare. Înainte de a pregăti mâncare sau de a mânca e important să vă spălați pe mâini cu apă și săpun timp de 20 de secunde pentru siguranța alimentară generală. Pe toată durata zilei spălați-vă pe mâini de fiecare dată când tușiți strănutați, vă suflați nasul sau mergeți la toaletă.</p>
            <p>Ar putea fi posibil ca o persoană să se îmbolnăvească de COVID-19 prin atingerea unei suprafețe sau a unui obiect care are virusul pe el, apoi atingându-și gura, nasul sau chiar ochii, dar aceasta nu pare să fie principala modalitate de răspândire.</p>
            <p>În general, deoarece coronavirusurile supraviețuiesc puțin timp pe suprafețe, riscul de îmbolnăvire de la ambalaje sau produse alimentare e foarte scăzut, acestea călătorind timp de zile sau chiar săptămâni la temperaturi ambientale, refrigerate sau congelate.</p>
        `,
      },
      {
        title: `Va opri vremea caldă epidemia de COVID-19?`,
        content: `
            <p>Nu se știe încă sigur dacă vremea și temperatura influențează răspândirea COVID-19. Alte virusuri, precum răceala sau gripa se răspândesc mai mult când vremea e rece dar asta nu înseamnă că e imposibil să te îmbolnăvești cu aceste virusuri în lunile calde. În acest moment nu știm dacă răspândirea COVID-19 va scădea când vremea se va încălzi. </p>
        `,
      },
      {
        title: `Ce e răspândirea comunitară?`,
        content: `
            <p>Răspândirea comunitară e când mai multe persoane au fost infectate într-o zonă, inclusiv unele persoane care nu sunt sigure de metoda prin care au fost infectate (nu se cunoaște sursa infectării).</p>
        `,
      },
      {
        title: `Pot să mă infectez în România?`,
        content: `
            <p>Situația evoluează foarte repede și riscul de infecție poate evolua zilnic. Consultați sursele oficiale la zi pentru a stabili riscul pentru dumneavoastră.</p>
        `,
      },
      {
        title: `Există cazuri în România?`,
        content: `
            <p>Da, există cazuri de COVID-19 în România, atât cazuri de persoane ce s-au întors în țară cu virusul cât și de persoane infectate local. Numărul oficial de infecții poate fi văzut <a href="http://www.datelazi.ro" target="_blank" rel="noopener noreferrer">aici</a></p>
        `,
      },
      {
        title: `Cum mă pot proteja?`,
        content: `
            <p>Momentan nu există un vaccin preventiv pentru coronavirusul care cauzează COVID-19.
Cea mai sigură metodă de evitare a infecției este să evitați expunerea la virus prin limitarea contactului cu alte persoane sau autoizolare (așa-numitele metode de distanțare socială).
</p>
            <p>Virusul se răspândește mai ales de la om la om:</p>
            <ul>
                <li>Între persoane care se află în contact direct (sub 1,5 m)</li>
                <li>Prin picături respiratorii produse de o persoană infectată care strănută sau care tușește. Aceste picături microscopice pot ajunge în gura sau nasul persoanelor aflate în apropiere sau pot fi inhalate direct în plămâni.</li>
            </ul>
            <p>Măsuri Preventive:</p>
            <ul>
                <li>Spălați-vă des pe mâini cu apă și săpun pentru cel puțin 20 de secunde, mai ales după ce ați fost în locații publice sau după ce ați strănutat, tușit sau v-ați suflat nasul.</li>
                <li>Dacă nu aveți posibilitatea de a vă spăla pe mâini, folosiți un dezinfectant  cu cel puțin 60% alcool. Acoperiți toată suprafața mâinilor și frecați mâinile până sunt uscate.</li>
                <li>Evitați să vă atingeți fața, în special gura nasul sau ochii cu mâinile murdare.</li>
                <li>Evitați contactul apropiat cu persoane care prezintă simptome respiratorii</li>
                <li>Distanțați-vă social de alte persoane, mai ales dacă COVID-19 se răspândește în comunitatea dumneavoastră. Acest lucru e în special important pentru persoane cu risc ridicat de îmbolnăvire gravă.</li>
                <li>Purtați mască în preajma altor persoane.</li>
            </ul>
            <p>Luați măsuri pentru a îi proteja pe alții:</p>
            <ul>
                <li>Stați acasă dacă sunteți bolnav.</li>
                <li>Dacă prezentați simptome specifice (tuse seacă repetată, febră, dificultăți în respirare),  contactați-vă medicul de familie pentru stabilirea posibilității infecției și pentru stabilirea testării pentru noul coronavirus la domiciliu. Pentru urgențe apelați numărul de urgență 112 și menționați simptomele dumneavoastră.</li>
                <li>Acoperiți-vă gura și nasul când strănutați sau tușiți cu un șervețel de unică folosință. Aruncați șervețelele folosite. Dacă nu aveți un șervețel la îndemână acoperiți-vă fața cu interiorul cotului.</li>
                <li>Spălați-vă imediat pe mâini cu apă și săpun pentru cel puțin 20 de secunde. Dacă nu vă puteți spăla folosiți dezinfectant cu cel puțin 60% alcool.</li>
                <li>Purtați mască în preajma altor persoane indiferent dacă sunteți sau nu bolnav.</li>
                <li>Dacă sunteți bolnav cu simptome respiratorii purtați o mască în preajma altor persoane, inclusiv înainte de prezentarea într-un cabinet medical. Dacă nu puteți purta mască (de exemplu dacă aveți dificultăți de respirație) faceți tot posibilul pentru a vă acoperi tusea sau strănutul. Persoanele care vă îngrijesc trebuie să poarte o mască atunci când intră în camera în care vă aflați.</li>
                <li>Dacă sunteți bolnav sau îngrijiți o persoană bolnavă, curățați și dezinfectați suprafețele atinse frecvent. Acestea includ mese, clanțe, comutatoare, blaturi mânere, birouri, telefoane, tastaturi, toalete, robineți și chiuvete.</li>
                <li>Curățați suprafețele murdare vizibil cu apă și săpun înainte de dezinfectare.</li>
            </ul>
            <p>Pentru a dezinfecta folosiți produse pe bază de clor, alcool peste 70% (de exemplu alcool sanitar) sau alte substanțe marcate ca fiind biocide sau virucide. Urmăriți instrucțiunile de pe produse pentru dozaj, aerisirea spațiului după dezinfectare sau perioada de dezinfectare.</p>
            <p>Fiți Pregătiți:</p>
            <ul>
                <li>Asigurați-vă că aveți un stoc din medicamentele pe care le luați în mod curent în caz că trebuie să stați acasă o perioadă mai îndelungată.</li>
                <li>Asigurați-vă că aveți medicamente fără rețetă pentru tratarea simptomelor afecțiunilor respiratorii. </li>
                <li>Faceți un mic stoc de produse esențiale neperisabile pentru a evita deplasările nenecesare.</li>
                <li>Consultați medicul de familie pentru mai multe detalii despre cum să vă monitorizați starea de sănătate pentru simptome.</li>
                <li>Țineți contactul cu prieteni sau membri familiei prin telefon sau internet - e posibil să aveți nevoie de ajutor cu cumpărături sau asistență medicală, mai ales dacă sunteți în grupele de risc ridicat.</li>
            </ul>
        `,
      },
      {
        title: `Ce să fac dacă am avut contact direct cu o persoană confirmată cu COVID-19?`,
        content: `
            <p>Contactați autoritățile la linia TELVERDE <a href="tel:0800800358">0800 800 358</a> Veți primi instrucțiuni punctuale. Între timp, evitați contactul cu alte persoane pe cât posibil.</p>
        `,
      },
      {
        title: `Cine e expus mai mult riscului de îmbolnăvire gravă cu COVID-19?`,
        content: `
            <p>Din datele disponibile până acum, persoanele cele mai expuse la o îmbolnăvire gravă cu COVID-19 sunt persoanele în vârstă și persoanele bolnave cronic de diabet, boli pulmonare, boli cardiace inclusiv hipertensiune.</p>
        `,
      },
      {
        title: `Ce pot face persoanele ce prezintă risc ridicat de îmbolnăvire?`,
        content: `
            <p>Dacă sunteți într-o grupă de risc:</p>
            <ul>
                <li>Asigurați-vă că aveți un stoc din medicamentele pe care le luați în mod curent în caz că trebuie să stați acasă o perioadă mai îndelungată.</li>
                <li>Stați acasă.</li>
                <li>Dacă trebuie să ieșiți din casă luați măsuri de precauție uzuale, stați departe de persoane bolnave, limitați contactul apropiat, spălați-vă des pe mâini, evitați orice fel de călătorie neesențială și evitați mulțimile. </li>
                <li>Fiți atenți la simptome, mai ales la cele grave. Dacă vă îmbolnăviți, contactați 112.</li>
            </ul>
        `,
      },
      {
        title: `Sunt expus la risc de îmbolnăvire cu COVID-19 dacă deschid pachete provenite din țări afectate ca China sau Italia?`,
        content: `
            <p>Momentan nu știm destule despre rata de supraviețuire a coronavirusului ce provoacă COVID-19 dar coronavirusurile au o rată scăzută de supraviețuire pe supraafețe iar pachetele stau zile dacă nu săptămâni pe traseu. Riscul de contaminare de la un pachet este foarte redus și nu avem dovezi de nici un caz la nivel mondial contaminat prin colete poștale.</p>
        `,
      },
      {
        title: `Care sunt simptomele COVID-19?`,
        content: `
            <p>Cele mai răspândite simptome pentru infecția cu noul coronavirus sunt:</p>
             <ul>
                <li>Febră</li>
                <li>Tuse seacă</li>
                <li>Dificultăți de respirație</li>
            </ul>
            <p>Acestea pot apărea între 2 și 14 zile după expunere. De obicei apar în primele 7 zile.</p>
            <p>Marea majoritate (80%) a persoanelor care se îmbolnăvesc prezintă simptome ușoare sau foarte ușoare, echivalentul unei răceli sau unei pneumonii ușoare. Un număr de aproximativ 15% prezintă complicații și au nevoie de spitalizare. Un număr de aproximativ 5% prezintă complicații grave necesitând tratament de urgență.</p>
            <p>Simptomele de urgență ale COVID-19 sunt:</p>
            <ul>
                <li>Dificultăți severe de respirație</li>
                <li>Durere sau presiune constantă în piept</li>
                <li>Confuzie</li>
                <li>Față sau buze albastre</li>
            </ul>
            <p>Această listă este doar una provizorie. Contactați-vă medicul de familie dacă prezentați orice tip de simptome asociate COVID-19. Pe baza simptomatologiei se poate dispune testarea pentru COVID-19 și spitalizarea într-unul din centrele specializate dacă se consideră necesar de către cadrele medicale. Contactați  numărul de urgență 112 doar în caz de simptome grave. O persoană trebuie să fie testată de două ori consecutiv cu un rezultat negativ, pentru a fi considerată vindecată.</p>
        `,
      },
      {
        title: `Poate o persoană ce a primit un diagnostic negativ la test să fie apoi testată și să fie identificată ca bolnavă cu COVID-19?`,
        content: `
            <p>Un test negativ înseamnă că virusul care cauzează COVD-19 nu a fost descoperit în mostra prelevată de la persoana testată. Un test “fals negativ” este posibil mai ales în perioada timpurie a infecției. În cazul COVID-19 un test negativ prelevat de la o persoană cu simptome înseamnă că persoana respectivă probabil suferă de o altă afecțiune respiratorie cum ar fi gripa sau răceala.</p>
        `,
      },
      {
        title: `Există orice medicamente sau terapii care previn sau tratează COVID-19?`,
        content: `
            <p>În timp ce unele tratamente medicamentoase sau remedii casnice pot oferi confort și ameliorează simptomele de COVID-19, nu există până în momentul de față dovezi clare că medicamentele existente pot preveni sau trata boala. Organizația Mondială a Sănătății <strong>nu</strong> recomanda auto-medicația, inclusiv administrarea de antibiotice, pentru prevenirea și tratarea COVID-19. Cu toate acestea, există studii clinice care evaluează diferite tratamente pentru COVD-19 și vom actualiza informațiile când acestea devin disponibile. </p>
        `,
      },
      {
        title: `Sunt antibioticele eficiente în prevenirea și tratarea COVID-19?`,
        content: `
            <p>Nu. Antibioticele nu funcționează împotriva virusurilor, acestea funcționează doar pentru infecții bacteriene. COVID-19 este cauzată de un virus, așadar antibioticele nu au rezultat. Antibioticele nu ar trebui folosite ca mijloc de prevenție sau tratament pentru COVID-19. Acestea ar trebui folosite doar la indicația medicului pentru a trata o infecție bacteriană.</p>
        `,
      },
      {
        title: `Există un vaccin, medicament sau tratament specific pentru COVID-19?`,
        content: `
            <p>Da! Au fost realizate mai multe vaccinuri care și-au dovedit eficiența până în prezent.</p>
            <p>Nu este recomandat să vă administrați singuri medicamente pentru tratarea COVID – 19, medicamentația poate fi administrată doar la recomandarea medicului și doar dacă este necesar.</p>
        `,
      },
      {
        title: `Pot animalele să răspândească virusul ce cauzează COVID-19?`,
        content: `
            <p>Deși boala a apărut prin transferul de la animal la om nu există nicio dovadă că animalele de curte sau animalele de companie prezintă vreun risc de transmisie al bolii. Animalele pot însă transmite alte boli virale sau bacteriene așa că se recomandă spălatul pe mâini după contactul cu animale.</p>
        `,
      },
      {
        title: `Dacă sunt infectat cu COVID-19 să evit contactul cu animalele de companie sau alte animale?`,
        content: `
            <p>Deși boala nu se transmite prin animale sau animale de companie din ce se cunoaște ar trebui să evitați contactul pe durata bolii nu doar cu alte persoane ci și cu animalele până cunoaștem mai multe despre evoluția acestei boli.</p>
        `,
      },
      {
        title: `Ar mai fi alte lucruri care nu ar fi recomandat să le fac?`,
        content: `
            <p>Conform Organizației Mondiale a Sănătății, următoarele comportamente nu sunt eficiente împotriva COVID-19 și pot fi dăunătoare:</p>
            <ul>
                <li>Fumatul</li>
                <li>Utilizarea măștilor chirurgicale multiple</li>
                <li>Folosirea antibioticelor</li>
            </ul>
        `,
      },
    ],
  },
  {
    title: "Întrebări frecvente",
    slug: "/",
    doc_type: "STATIC_PAGE",
    doc_id: 108,
    active: false,
    display_order: 1,
    showInTopMenu: true,
    showInSideMenu: true,
    content: [
      {
        title: "Cum acționez dacă am simptome sau sunt confirmat cu COVID-19",
        display_order: 1,
        page: `<p>Cum acționez dacă am simptome sau sunt confirmat cu COVID-19</p>`,
        slug: "/",
      },
    ],
    firstNodeId: null,
    form: null,
    buttons: null,
    accordion: [
       {
        title: `Sunt răcit și resimt dureri în gât, nas înfundat, etc. Cum îmi dau seama dacă e grav, dacă e doar o simplă viroză, gripă sau dacă sunt infectat cu noul Coronavirus?`,
        content: `
            <p>Recomandarea generală este să evitați interacțiunea cu alte persoane și să rămâneți acasă. De asemenea, dacă evitarea interacțiunii cu alte persoane este imposibilă, vă recomandăm să purtați mască atunci când interacționați cu alte persoane, inclusiv cu membrii familiei.</p>
            <p>Prezența acestor simptome nu presupune automat infectarea cu noul Coronavirus (COVID-19).</p>
            <p>Asigurați-vă că aveți la îndemână un termometru pentru a vă măsura regulat temperatura corporală.</p>
            <p>Primul pas este sa sunați medicul de familie și să-i descrieți simptomele. Medicul dumneavoastră vă va îndruma dacă este necesar sau nu să efectuați un test pentru COVID-19 și care este medicația care trebuie să o administrați.</p>
            <p>(NOTĂ: Simptomele cel mai des intalnite in cazul infectiei COVID-19 sunt: tuse seacă, febră, scurtarea respirației, pierderea  bruscă a mirosului, a gustului, sau a ambelor. La aceste simptome se pot asocia dureri de cap, dureri musculare. Copiii cu vârsta până în 16 ani pot prezenta manifestări gastro-intestinale (vărsături, diaree) neasociate cu alimentația.)</p>
        `,
      },
      {
        title: `Starea mea de sănătate s-a alterat brusc, am dureri musculare, febră, tușesc, am rămas fără gust și miros, am diaree și dureri de cap. Nu am călătorit în ultima vreme în afara țării, nu am fost în zone aglomerate, nu am mers la restaurant sau la vreo petrecere, am purtat masca la serviciu, în mijloacele de transport în comun și nu am cunoștință să fi intrat în contact cu vreo persoană depistată pozitiv cu noul Coronavirus (COVID-19). Ce fac? Cum aflu dacă sunt sau nu infectat?”, COVID-19?`,
        content: `
            <p>Și în acest caz, primul la care trebuie să apelați este medicul de familie care va face o evaluare telefonică a stării dvs. și va decide calea de urmat. Medicul poate decide, în această situație, că trebuie să vă testați pentru COVID-19 și, ca atare, vă îndruma să sunați la Direcția de Sănătate Publică și să menționați toate simptomele. În tot acest timp, încercați pe cât de mult posibil să stați departe sau chiar să vă izolați de restul familiei, dacă vă permite spațiul locuinței. Rămâneți în casă și așteptați serviciul de ambulanță, ce vă va consulta, va realiza testarea la domiciliu, sau dacă situația o impune, vă va transporta la spital.</p>
            <p>În cazul persoanelor simptomatice, precum dumneavoastră, testarea se face conform protocolului, gratuit. </p>
            <p>De asemenea, există posibilitatea să vă testați „la cerere”, însă această opțiune este contra cost. Dacă mergeți la un centru de testare pentru a efectua testul „la cerere”, optați pe cât posibil pentru un mijloc de transport individual și respectați cu strictețe toate măsurile sanitare (mască, distanță, igiena mâinilor).</p>
        `,
      },
      {
        title: `Mă simt foarte rău de câteva zile, nu știu să fi intrat în contact cu vreo persoană bolnavă de Coronavirus, dar totuși mi-e teamă că am COVID-19.`,
        content: `
            <p>Sunați medicul de familie pentru orice problemă de sănătate. Doar dacă, în cazul puțin probabil, medicul dvs. nu răspunde la telefon și starea dvs. de sănătate se înrăutățește, atunci sunați la 112.</p>
        `,
      },
      {
        title: `Copilul meu de 4 ani a mers la grădiniță, iar educatoarea a fost diagnosticată cu COVID-19. Copilul nu a purtat mască, însă educatoarea a purtat masca. Copilul nu are nici un simptom și se spune că cei mici sunt mai degrabă asimptomatici decât adulții. Mă tem că este purtător, iar noi părinții am putea să luăm de la el. Cum procedez?`,
        content: `
            <p>Cel mai probabil în acest caz, educatoarea a stat în aceeași sală de clasă cu copilul mai mult de 15 minute, iar copilul nepurtând mască este contact direct. Educatoarea are obligația să declare la DSP toți contacții direcți pentru desfășurarea anchetei epidemiologice.</p>
            <p>Întreaga grupă își va suspenda activitatea timp de 14 zile. Copilul dvs. are indicația de carantină timp de 14 zile. În această situație, unul dintre părinți va rămâne acasă împreună cu copilul. Copilul și părintele ce rămâne acasă se vor izola pe cât posibil de restul familiei.</p>
            <p>Contactati medicul de familie și informați-l despre faptul că minorul este contact direct cu caz confirmat. În cazul în care copilul manifestă simptome clinice informați medicul și urmați indicațiile acestuia. Dacă cel mic este pozitiv, atunci toți membrii familiei care locuiesc în aceeași casă vor fi considerați la rândul lor contacți direcți și se va dispune carantina pentru 14 zile, cu excepția persoanelor care sunt vaccinate cu schema completă sau a persoanelor care au trecut prin boală și se află în perioada cuprinsă între 14 și 180 de zile de la diagnosticare cu COVID – 19.</p>
        `,
      },
      {
        title: `Am petrecut câteva ore la terasă cu un amic, nici unul nu a purtat mască. La două zile distanță, el a fost diagnosticat cu COVID-19, însă eu nu am nici un simptom. Ce trebuie să fac? `,
        content: `
            <p>În acest caz, cu excepția situației în care sunteți vaccinat cu schema completă sau a persoanelor care au trecut prin boală și se află în perioada cuprinsă între 14 și 180 de zile de la diagnosticarea cu COVID – 19,  sunteți contact direct și trebuie să rămâneți la domiciliu pentru următoarele 14 zile. Sunați medicul de familie care va anunța Direcția de Sănătate Publică de faptul că vă are sub observație, iar DSP va dispune carantina în cazul dv. Având în vedere că nu ați dezvoltat simptome, iar starea de sănătate este bună, nu este necesară testarea. Medicul de familie va păstra legătura cu dvs. până la epuizarea celor 14 zile. </p>
        `,
      },
      {
        title: `Mă număr printre persoanele care au luat contact direct cu o persoană confirmată cu COVID-19, dar Direcția de Sănătate Publică nu mi-a comunicat când voi fi testat. Pot alege să realizez un test „la cerere”, contra cost, la un centru de testare ales de mine?`,
        content: `
            <p>Sunteți considerat contact direct dacă ați avut contact apropiat, conform definiției INSP, în ultimele 3 zile înainte ca persoana confirmată să dezvolte simptome, sau în ultimele 3 zile de la data prelevării probei persoanei confirmate. Din moment ce vă numărați printre contacții direcți ai unei persoane confirmată pozitiv cu noul Coronavirus (COVID-19), Direcția de Sănătate Publică emite o decizie de carantinare de 14 zile de la data ultimului contact cu persoana confirmată, prin care vă este interzis să părăsiți domiciliul. Testarea dumneavoastră se va face doar în cazul în care manifestați simptome specifice. Chiar în cazul în care v-ați testa la cerere, un eventual test negativ nu reduce perioada de carantinare. Ieșirea temporară din carantină pentru efectuarea unui test este posibilă doar cu acordul DSP, care emite decizie în acest sens.</p>
            <p>Este important de știut faptul că persoanele vaccinate cu schema completă și cele care au trecut prin boală și se află în perioada cuprinsă între 14 și 180 de zile de la diagnosticarea cu COVID – 19, nu intră în carantină dacă au luat contact cu o persoană confirmată pozitiv, însă și în acest caz se recomandă anunțarea medicului de familie și observare stării de sănătate.</p>
        `,
      },
      {
        title: `Au trecut cele 14 zile de când m-am izolat la domiciliu cu diagnostic pozitiv de COVID-19. Mă simt foarte bine, nu mai am simptome, dar nu mă sună nimeni să-mi spună ce să fac. Cum procedez ? Pot să ies din casă?`,
        content: `
            <p>În cazul în care ați epuizat perioada de 14 zile, dispusă prin decizia DSP, puteți părăsi locuința. Contactați medicul de familie, care v-a monitorizat în toată această perioadă pentru a vă confirma vindecarea către DSP și pentru a primi sfaturi în ceea ce privește conduita dumneavoastră ulterioară.</p>
        `,
      },
      {
        title: `Dacă vin din țările de pe lista roșie care sunt condițiile pe care trebuie să le îndeplinesc ca să nu intru în carantină?`,
        content: `
            <p>Cetățenii care sosesc în România de pe statele aflate în zona roșie intră în carantină, la domiciliu sau instituționalizată, cu următoarele excepții:</p>
            <ul>
                <li>-	Dacă fac dovada vaccinării cu schema completă, schema finalizată în urmă cu cel puțin 10 zile;</li>
                <li>-	Dacă fac dovada trecerii prin boală și dacă se află în intervalul cuprins între 14 și 180 de zile de la diagnosticarea cu SRAS-COV-2;</li>
                <li>- Copiii cu vârsta mai mica sau egală cu 6 ani;</li>
                <li>-	Copiii cu vârsta între 6 și 16 ani, cu condiția prezentării rezultatului negativ al unui test RT-PCR efectuat cu cel mult 72 de ore îaintea intrării în țară sau a îmbarcării în avion;</li>
                <li>-	Persoanele aflate în tranzit, dacă părăsesc România în cel mult 24 de ore de la intrarea pe teritoriul tării</li>
                <li>-	Persoanele care rămân pe teritoriul național pentru o perioadă mai mică de 3 zile (72 de ore) și prezintă rezultatul negativ al unui test RT-PCR pentru infecția cu virusul SARSCoV-2, efectuat cu cel mult 72 de ore înaintea îmbarcării (pentru cei care călătoresc cu mijloace de transport în comun) sau intrării pe teritoriul național (pentru cei care călătoresc cu mijloace proprii). În situația în care persoanele nu părăsesc teritoriul național în cele 3 zile (72 de ore), cu informarea direcției de sănătate publică din județul în care locuiesc sau în care au adresa declarată la intrarea în țară, vor fi carantinate pentru o perioadă de 14 zile, începând cu cea de-a patra zi ulterioară intrării pe teritoriul României;</li>
                <li>-	Categoriile profesionale exceptate de la carantină prin hotărâri ale CNSU sau hotărâri de guvern. </li>
            </ul>
            <p>Atenție! Persoanele peste 16 ani nu sunt exceptate de la carantină atunci când vin din zonele roșii chiar dacă prezintă rezultatul negativ al unui test RT-PCR, cu excepția situației în care părăsesc teritoriul național în cel mult 3 zile (72 de ore).</p>
            <p>Doar în cazul persoanelor care sosesc din state aflate în zona galbenă, adulții pot folosi și ei rezultatul negativ al unui test RT-PCR pentru a fi exceptați de la carantină</p>
        `,
      },
      {
        title: `Cum pot afla dacă intru în carantină sau ce conditii trebuie să îndeplinesc dacă plec din România în altă țară?`,
        content: `
            <p>Informațiile privind condițiile de călătorie sunt postate și actualizate pe siteul web a Ministerului Afacerilor Externe, la capitolul condiții de călătorie. </p>
            <p>De asemenea, pe paginile web ale ambasadelor României acreditate în respectivele țări sunt postate informații privind condițiile ce trebuie respectate în statele gazdă.</p>
        `,
      },
      {
        title: `Cum mă pot proteja de varianta delta a virusului?`,
        content: `
            <p>Măsurile sanitare de protecție recomandate în cazul variantei delta a SARS-COV-2 sunt aceleași ca pentru celelalte variante: evitarea zonelor aglomerate, evitarea contactului cu persoanele care sunt pozitive sau suspecte, purtarea măștii de protecție, igiena corectă a mâinilor, evitarea contactului cu suprafețe atinse des de alte persoane.</p>
            <p>Varianta delta este mai contagioasă și se transmite mai ușor, însă măsurile de protecție recomandate până acum sunt eficiente și împotriva acestei tulpini, dacă sunt aplicate corect.</p>
        `,
      },
    ],
  },
  {
    title: "Întrebări despre vaccinare",
    slug: "intrebari-despre-vaccinare",
    doc_type: "STATIC_PAGE",
    doc_id: 301,
    active: true,
    display_order: 2,
    showInTopMenu: true,
    showInSideMenu: true,
    content: [
      {
        title: "Întrebări și răspunsuri despre vaccinare",
        display_order: 1,
        page: `<p>Întrebări și răspunsuri despre vaccinare. Sursa: <a href="https://vaccinare-covid.gov.ro/" target="_blank">https://vaccinare-covid.gov.ro/</a></p>`,
        slug: "/",
      },
    ],
    firstNodeId: null,
    form: null,
    buttons: null,
    accordion: [
      {
        title: `De ce să mă vaccinez împotriva COVID-19?`,
        content: `
            <p>Vaccinarea împotriva COVID-19 este importantă pentru că reduce riscul de îmbolnăvire și riscul de a dezvolta o formă severă de boală. Vaccinarea este un instrument important pentru a opri răspândirea pandemiei, scădea supraîncărcarea unităților sanitare, permițând, astfel, redeschiderea unităților sanitare pentru pacienții non-COVID. Astfel, vor fi create condițiile pentru redeschiderea activităților socio-economice și înlesnirea liberei circulații.</p>
        `,
      },
      {
        title: `Cum sunt protejate datele cu caracter personal privind vaccinarea împotriva COVID-19?`,
        content: `
            <p>Monitorizarea nivelului de acoperire vaccinală, a siguranței și eficacității vaccinurilor împotriva COVID-19 se realizează cu ajutorul platformelor electronice, respectându-se legislația cu privire la protecția datelor cu caracter personal. Conform strategiei privind vaccinarea împotriva COVID-19 în România se va dezvolta un modul dedicat vaccinării împotriva COVID-19 în cadrul Registrului Electronic Național de Vaccinare (RENV), care va constitui baza de date electronică referitoare la vaccinare, cu respectarea prevederilor legale privind protecția datelor cu caracter personal.</p>
        `,
      },
      {
        title: `Ce document se va elibera în momentul vaccinării?`,
        content: `
            <p>Fiecare persoană care se va vaccina va primi o adeverință doveditoare de vaccinare care va cuprinde următoarele informații: numele și prenumele persoanei vaccinate, data nașterii, vârsta, județul de domiciliu, număr și serie CI, date despre vaccin: doza 1 (tip vaccin, produs, serie/lot, data expirării), doza 2 (tip vaccin, produs, serie/lot, data expirării), date despre centrul de vaccinare (nume centru de vaccinare, județ, medic coordonator/vaccinator), semnătura electronică a Registrului Electronic Național al Vaccinărilor.</p>
            <p>Dovada vaccinării este pusă la dispoziția persoanei vaccinate fie electronic, fie pe suport de hârtie pentru a-i permite acesteia să își țină evidența între cele două vizite la centrul de vaccinare (doză inițială și rapel) și pentru a-i pune la dispoziție informațiile esențiale despre caracteristicile vaccinului administrat. Precizăm că vaccinarea este gratuită, voluntară/ neobligatorie, iar adeverința doveditoare nu este eliberată cu scopul de  a condiționa sau restricționa ulterior drepturile persoanelor vaccinate.</p>
        `,
      },
      {
        title: `Dacă am fost infectat cu SARS-CoV-2, mai este necesară vaccinarea?`,
        content: `
            <p>În studiile clinice, vaccinul a fost administrat și unor persoane care prezentau un nivel detectabil de anticorpi anti SARS-CoV-2 și nu s-au detectat efecte adverse, ci doar o creștere a nivelului de răspuns imun.  Vaccinarea este disponibilă, pe baza consimțământului, indiferent dacă a existat sau nu infectarea.</p>
        `,
      },
      {
        title: `Persoanele nevaccinate le pot infecta pe cele vaccinate?`,
        content: `
            <p>O persoană nevaccinată se poate infecta cu virusul SARS-CoV-2 și-l poate transmite celor cu care intră în contact. Contacții vaccinați (vaccin Pfizer/BioNTech, aprobat condiționat în Uniunea Europeană) ai persoanei nevaccinate sunt protejați față de de dezvoltarea bolii Covid-19 – chiar dacă virusul ar putea ajunge în căile respiratorii, transmis de la un purtător, nu va produce efecte, fiind inactivat de anticorpii protectori dezvoltați după vaccinare.</p>
        `,
      },
      {
        title: `Persoanele vaccinate le pot infecta pe cele nevaccinate?`,
        content: `
            <p>Obiectivul principal al studiului de faza 3 pentru vaccinul Pfizer/BioNTech, aprobat condiționat în Uniunea Europeană, nu a presupus măsurarea transmisibilității SARS-CoV-2 după vaccinare, ci demonstrarea eficacității pentru prevenirea bolii Covid-19. Date despre măsura în care o persoană vaccinată mai poate transmite virusul urmează a fi generate, colectate și analizate în perioada următoare. Experiența cu alte vaccinuri arată că în general o persoană vaccinată transmite într-o mai mică măsură agentul patogen, dar această ipoteză trebuie validată și pentru SARS-CoV-2.</p>
        `,
      },
      {
        title: `De unde mă pot informa cu privire la vaccinurile candidate?`,
        content: `
            <p>La nivelul Uniunii Europene, vaccinurile care vor fi folosite în campaniile de vaccinare împotriva COVID-19 sunt cele care au primit aprobarea din partea Agenției Europene a Medicamentului. Toate detaliile cu privire la procesul de evaluare și aprobare sunt disponibile și actualizate constant pe site-ul <a target="_blank" href="https://www.ema.europa.eu/en/human-regulatory/overview/public-health-threats/coronavirus-disease-covid-19/treatments-vaccines/covid-19-vaccines-development-evaluation-approval-monitoring">Agenției Europene a Medicamentului</a>.</p>
        `,
      },
      {
        title: `Cu cine iau legătura dacă vreau să mă vaccinez?`,
        content: `
            <p>Conform Strategiei pentru vaccinarea împotriva COVID-19 în România, vaccinarea se va realiza în etape, respectând grupele populaționale. Pentru etapa I, vaccinarea se va organiza la locul de muncă și prin centrele de vaccinare fixe și mobile, iar pentru etapele II și III vaccinarea se va organiza prin centre de vaccinare fixe și mobile, echipe mobile, rețeaua de medicină de familie, centre drive-through.</p>
        `,
      },
      {
        title: `Pot refuza să mă vaccinez?`,
        content: `
            <p>Da, conform strategiei pentru vaccinarea împotriva COVID-19 în România vaccinarea este voluntară și ne-obligatorie.</p>
        `,
      },
      {
        title: `Vaccinarea este gratuită?`,
        content: `
            <p>Da, conform strategiei pentru vaccinarea împotriva COVID-19 în România vaccinarea este gratuită.</p>
        `,
      },
      {
        title: `Dacă mă vaccinez, mai este necesar să respect celelalte măsuri igienico-sanitare?`,
        content: `
            <p>Administrarea unui vaccin împotriva COVID-19 reprezintă unul dintre instrumentele critice pentru limitarea efectelor pandemiei, alături de celelalte instrumente: respectarea restricțiilor și a măsurilor igienico-sanitare (purtarea măștii, spălatul pe mâini și distanțarea fizică).</p>
        `,
      },
      {
        title: `Persoanele cu condiții medicale preexistente sunt eligibile pentru vaccinare?`,
        content: `
            <p>Conform strategiei naționale de vaccinare împotriva COVID-19, persoanele aflate în evidență cu boli cronice, indiferent de vârstă, sunt prioritare în vederea vaccinării, luându-se în considerație indicațiile și contraindicațiile vaccinurilor utilizate.</p>
        `,
      },
      {
        title: `O persoană care a fost infectată cu SARS-CoV-2 se poate vaccina?`,
        content: `
            <p>Da, o persoana care a fost infectată cu SARS-CoV-2 poate fi vaccinată în mod voluntar, atunci când întrunește criteriile legate de prioritizare. Nu se are în vedere excluderea de la vaccinare a persoanelor cu infecție anterioară cunoscută și nici testarea persoanelor înaintea vaccinării.</p>
            <p>În momentul de față nu se știe pentru cât timp după infecție suntem protejați și nici nivelul de anticorpi necesar pentru a fi protejați. <a target="_blank" href="https://science.sciencemag.org/content/370/6521/1227">Studii recente</a> arată că la majoritatea persoanelor, anticorpii neutralizanți (cei care pot bloca infectarea celulelor) persistă cel puțin câteva luni de la infecția inițială. De asemenea, studiile arată că răspunsul imun în urma infecției naturale poate varia foarte mult în funcție de individ și de severitatea bolii.</p>
            <p><a target="_blank" href="https://www.fda.gov/media/139638/download">Autoritățile de reglementare</a> nu recomandă excluderea participanților la studiile clinice din Faza 3 pe baza dovezilor despre o infecție anterioară astfel încât majoritatea producătorilor <a target="_blank" href="https://www.bmj.com/content/bmj/371/bmj.m4058.full.pdf">au vaccinat deja și persoane care au trecut prin boală</a>, fără a fi raportate reacții adverse severe.</p>
        `,
      },
      {
        title: `Ce sunt centrele de vaccinare drive-through?`,
        content: `
            <p>Centrele de vaccinare drive-through sunt centre de vaccinare fixe amenajate în mod special pentru etapa a III-a a procesului de vaccinare care este adresată populației generale. Conform recomandărilor Organizației Mondiale a Sănătății, organizarea și amenajarea  acestor centre se vor face în marile aglomerări urbane, în zone care permit accesul persoanelor cu mijloace auto proprii. Organizarea și amenajarea centrelor de vaccinare drive-through se vor face cu respectarea tuturor normelor de siguranță și a normelor igienico-sanitare, pentru a facilita accesul persoanelor la vaccinare, a eficientiza procesul de vaccinare, a evita supraaglomerarea sau sacrificarea dozelor de vaccin. Organizarea unor astfel de centre drive-through este propusă prin strategia <a target="_blank" href="https://apps.who.int/iris/handle/10665/335940">Organizației Mondiale a Sănătății.</a></p>
        `,
      },
      {
        title: `Ce sunt centrele mobile de vaccinare?`,
        content: `
            <p>Centrele mobile de vaccinare sunt centre de vaccinare/caravane mobile organizate în diferite etape ale procesului de vaccinare. Organizarea și amenajarea  acestor centre mobile de vaccinare se vor face, atunci când este necesar, pentru a facilita accesul la vaccinare al persoanelor ce deservesc activități esențiale, al persoanelor aflate în centre rezidențiale și medico-sociale și, după caz, al persoanelor din rândul populației generale pentru care accesul la vaccinare este limitat. Organizarea și amenajarea centrelor mobile de vaccinare se vor face cu respectarea tuturor normelor de siguranță și a normelor igienico-sanitare, pentru a facilita accesul persoanelor la vaccinare, a eficientiza procesul de vaccinare, a evita supraaglomerarea sau sacrificarea dozelor de vaccin.</p>
        `,
      },
      {
        title: `Ce  este o autorizație condiționată  de punere pe piață (CMA)?`,
        content: `
            <p>În cadrul Uniunii Europene, o autorizație condiționată de punere pe piață permite autorizarea unor medicamente care se adresează unei nevoi neacoperite încă, pe baza unor date mai puțin complete decât cele solicitate în mod uzual. Acest lucru se întâmplă în condiții de urgență de sănătate publică, precum pandemia de Covid-19, doar dacă beneficiile cântăresc mult mai mult decât posibilele riscuri create de faptul că nu sunt disponibile încă toate datele. Autorizațiile condiționate sunt utilizate în cazul pandemiei de Covid-19 pentru a răspunde urgenței legate de sănătatea publică. Chiar și așa, datele furnizate trebuie să indice în mod clar faptul că beneficiile medicamentului sau ale vaccinului prevalează în fața posibilelor riscuri. Cerința ca beneficiile să fie mult mai mari în raport cu posibilele riscuri este cu atât mai explicită în cazul vaccinurilor ce se vor administra persoanelor sănătoase. O dată ce o astfel de autorizație condiționată a fost emisă, companiile trebuie să furnizeze mai multe date, din studii aflate în desfășurare sau din studii noi, la termene prestabilite, pentru a demonstra, în continuare, că beneficiile sunt mai mari decât riscurile.</p>
        `,
      },
      {
        title: `Ce se întâmplă după ce o companie depune cererea de autorizare de punere pe piață a unui vaccin? `,
        content: `
            <p>În cazul în care Agenția Europeană a Medicamentului va ajunge la concluzia că beneficiile vaccinului sunt mai mari decât riscurile, va recomanda Comisiei Europene acordarea autorizației condiționate de punere pe piață. Comisia va accelera apoi procedurile de decizie și, în câteva zile, autorizația ar putea fi adoptată la nivelul statelor membre UE și al statelor EEA.</p>
            <p>Ca și pentru alte medicamente, autoritățile de reglementare ale UE vor continua să adune și să evalueze noi informații și după punerea pe piață și să ia măsuri dacă și atunci când este nevoie. Respectând planul european pentru monitorizarea siguranței vaccinurilor împotriva COVID-19, monitorizarea se va face mai des și va include activități specifice pentru aceste vaccinuri. De exemplu, în plus față de actualizările periodice cerute de legislație, companiile vor furniza rapoarte lunare care monitorizează siguranța și vor realiza studii pentru monitorizarea siguranței și eficacității vaccinurilor COVID-10, chiar și după autorizarea lor.  Aceste măsuri le vor permite autorităților de reglementare să evalueze date care provin din surse diferite și să ia măsurile care se impun pentru protejarea sănătății publice, dacă este cazul.</p>
        `,
      },
      {
        title: `Cum funcționează vaccinurile pentru care au fost depuse cereri de obținere a autorizațiilor de punere pe piață?  (BNT162b2 și RNA1273)`,
        content: `
            <p>Vaccinurile vor pregăti organismul uman să se apere împotriva COVID-19. Pentru a pătrunde în organism și pentru a cauza boala, virusul SARS-CoV-2 utilizează o proteină aflată pe învelișul său, proteină denumită proteina S (spike). Vaccinurile conțin instrucțiunile genetice (ARN mesager) necesare pentru generarea proteinei S. Când o persoană este vaccinată, celulele sale vor ”citi” instrucțiunile genetice din ARN-ul mesager și vor sintetiza proteina S. Sistemul imun al persoanei respective va recunoaște această proteină ca fiind străină și va declanșa mecanismele de apărare imună, producând anticorpi  și celule T specifice. Dacă mai târziu, persoana vaccinată va intra în contact cu virusul SARS-CoV-2, sistemul său imun va recunoaște virusul și, prin intermediul anticorpilor și al celulelor T specifice, va neutraliza virusul, prevenind, astfel, intrarea în celulele sănătoase ale corpului și distrugând eventualele celule infectate. Astfel, se va asigura protecția împotriva COVID-19.</p>
        `,
      },
    ],
  },
  {
    title: "Programul de vaccinare",
    slug: "programul-de-vaccinare",
    doc_type: "STATIC_PAGE",
    doc_id: 302,
    active: true,
    display_order: 3,
    showInTopMenu: true,
    showInSideMenu: true,
    style: { "--highlightColor": "#F6DD62" },
    content: [
      {
        title: "Procesul de vaccinare în România",
        display_order: 1,
        slug: "/",
        page: `
        <p>Vaccinarea împotriva COVID-19 în România se va realiza în trei etape, în care vor fi vaccinate grupele populaționale, după cum urmează:</p>
        <h3>Etapa I:</h3>
        <ul>
          <li><strong>Cât durează?</strong> Timpul de execuție va fi stabilit în funcție de schema de vaccinare aleasă, care poate cuprinde una sau două doze;</li>
          <li><strong>Cine?</strong> Persoanele incluse în categoria lucrătorilor din domeniile sănătății și social – sistem public și privat;</li>
          <li><strong>Cum?</strong> Vaccinarea se va realiza prin intermediul unităților sanitare sau a centrelor de vaccinare ori a echipelor mobile de vaccinare – în funcție de situație.</li>
        </ul>
        <h3>Etapa a II-a:</h3>
        <ul>
          <li><strong>Cât durează?</strong> Timpul de execuție va fi stabilit în funcție de schema de vaccinare aleasă, care poate cuprinde una sau două doze;</li>
          <li><strong>Cine?</strong> Include populația cu grad de risc și lucrători care desfășoară activități în domenii-cheie, esențiale;</li>
          <li><strong>Cum?</strong> Se derulează prin rețeaua de centre de vaccinare/echipe mobile de vaccinare/medicină de familie, după caz.</li>
        </ul>
        <h3>Etapa a III-a:</h3>
        <ul>
          <li><strong>Cât durează?</strong> Timpul de execuție va fi stabilit în funcție de schema de vaccinare aleasă, care poate cuprinde una sau două doze;</li>
          <li><strong>Cine?</strong> Include populația generală;</li>
          <li><strong>Cum?</strong> Se derulează prin rețeaua de centre de vaccinare/echipe mobile de vaccinare/medicină de familie/centre de vaccinare drive-through, după caz.</li>
        </ul>
        <h3>Grupele populaționale pentru vaccinarea împotriva COVID-19:</h3>
        <p>Pentru stabilirea și prioritizarea grupelor populaționale, au fost luate în considerare următoarele criterii:</p>
        <ul>
          <li><strong>principiile de etică și echitate socială;</strong></li>
          <li><strong>criteriile epidemiologice</strong> care să permită flexibilitate în alocarea vaccinului la nivel regional și local – în funcție de evoluția infecției în teritoriu, de ex: creșterea rapidă, exponențială a numărului de cazuri peste o anumită valoare prag (definirea unui prag de incidență) la nivelul unei regiuni va permite, în funcție de caracteristicile populației, distribuirea prioritară a vaccinurilor la nivelul populației respective pentru limitarea răspândirii virusului;</li>
          <li><strong>criteriile medicale</strong> impactul infecției cu SARS-CoV-2 la nivel individual și colectiv:</li>
                <ul>
                  <li>riscul de infecție cu SARS-CoV-2;</li>
                  <li>riscul de evoluție severă și deces în caz de infecție;</li>
                  <li>riscul de transmitere a infecției de la persoana infectată la restul persoanelor;</li>
                </ul>
          <li><strong>activitățile esențiale</strong> care asigură buna funcționare a infrastructurii critice;</li>
          <li>în cadrul aceleași categorii pot fi prioritizate subcategorii în raport cu criteriile medicale, evoluția epidemiologică, indicațiile și contraindicațiile tipurilor de vaccinuri aprobate, disponibilitatea vaccinurilor.</li>
        </ul>
        <h3>Grupurile  prioritare pentru vaccinarea împotriva COVID-19</h3>
        <ul>
          <li>Personalul din domeniul sănătății</li>
          <li>Personalul din centre rezidențiale și medico-sociale</li>
          <li>Populația cu risc ridicat de evoluție severă în cazul infecției cu SARS-CoV-2</li>
          <li>Personalul din alte domenii-cheie, esențiale bunei  funcționări a societății</li>
        </ul>
        <h3>Populația prioritizată pentru vaccinarea împotriva COVID-19 este:</h3>
        <h4>Etapa I – lucrătorii din domeniul sănătății și social – sistem public și privat:</h4>
        <ul>
          <li>Personalul din spitale și unități ambulatorii (personalul medico-sanitar, personalul auxiliar, personal administrativ, securitate și pază și alte categorii);</li>
          <li>Personalul din sistemul de medicină de urgență: ambulanță, SMURD, IGSU, IJSU, camere de gardă, CPU, UPU;</li>
          <li>Personalul din medicina primară – din rețeaua de medicină de familie, medicină școlară și asistență medicală comunitară;</li>
          <li>Personalul din laboratoare, farmacii și alți lucrători din domeniul sănătății;</li>
          <li>Personalul din serviciile stomatologice;</li>
          <li>Medici rezidenți, elevi și studenți cu profil medical;</li>
          <li>Paramedici și alți voluntari care își desfășoară activitatea în unități sanitare;</li>
          <li>Personalul de îngrijire care își desfășoară activitatea în centrele rezidențiale și medico-sociale;</li>
          <li>Personalul care acordă îngrijiri medicale și sociale la domiciliu;</li>
          <li>Personalul din serviciile de sănătate publică (Institutul Național de Sănătate Publică, Direcțiile de Sănătate Publică);</li>
          <li>Personalul din unitățile sanitare ale ministerelor cu rețea sanitară proprie;</li>
          <li>Personalul din centrele de dializă și transfuzii;</li>
          <li>Personalul implicat în derularea campaniilor de vaccinare.</li>
        </ul>

        <h4>Etapa a II-a</h4>
        <h4>Populația cu grad ridicat de risc</h4>
        <ul>
          <li>Adulți cu vârsta peste 65 de ani;</li>
          <li>Persoanele aflate în evidență cu boli cronice, indiferent de vârstă, în funcție de indicațiile vaccinurilor utilizate.</li>
        </ul>

        <h4>Lucrători care desfășoară activități în domenii-cheie, esențiale:</h4>
        <ul>
          <li>Personal cheie pentru funcționarea instituțiilor statului (parlament, președinție, guvern, ministere și instituții subordonate acestora);</li>
          <li>Personalul din domeniul apărării, ordinii publice, siguranței naționale și a autorității judecătorești;</li>
          <li>Personalul din sectorul economic vital:</li>
              <ul>
                <li>Procesare, distribuție și comercializare a alimentelor de bază (panificație, lactate, carne, fructe și legume);</li>
                <li>Uzine de apă, epurare, transport și distribuție apă;</li>
                <li>Centrale electrice, producție, transport și distribuție curent electric;</li>
                <li>Unități de producție, transport și distribuție gaze;</li>
                <li>Unități de producție, transport și distribuție combustibili lichizi și solizi;</li>
                <li>Unități de producție, transport și distribuție medicamente și materiale sanitare;</li>
                <li>Transport de persoane și mărfuri;</li>
                <li>Noduri feroviare, aeroporturi civile și militare, porturi esențiale;</li>
                <li>Comunicații (serviciul de telecomunicații speciale, radio și televiziune naționale);</li>
              </ul>
          <li>Personalul din unitățile de învățământ și creșe;</li>
          <li>Personalul poștal și din servicii de curierat;</li>
          <li>Personalul cultelor religioase;</li>
          <li>Personalul din mass media care desfășoară activități cu risc crescut de expunere la infecția cu SARS-CoV-2 (ex: reportaje în unități medicale);</li>
          <li>Personalul din domeniul salubrității și deșeurilor.</li>
        </ul>

        <h4>Etapa a III-a (populația generală)</h4>
        <ul>
          <li>Populația adultă;</li>
          <li>Populația pediatrică, în funcție de evoluția epidemiologică și de caracteristicile vaccinurilor aprobate pentru utilizarea la persoanele cu vârsta sub 18 ani.</li>
        </ul>

        <p>Sursa: <a href="https://vaccinare-covid.gov.ro/" target="_blank">https://vaccinare-covid.gov.ro/</a></p>
       `,
      },
    ],
    firstNodeId: null,
    form: null,
    buttons: null
  },
  {
    title: "Mituri despre coronavirus",
    slug: "mituri-despre-coronavirus",
    doc_type: "STATIC_PAGE",
    doc_id: 107,
    active: false,
    display_order: 102,
    showInTopMenu: false,
    showInSideMenu: false,
    content: [
      {
        title: "Mituri despre coronavirus",
        display_order: 1,
        page: `<p>GHID ÎNTREBĂRI ȘI MITURI</p>`,
        slug: "/",
      },
    ],
    firstNodeId: null,
    form: null,
    buttons: null,
    accordion: [
      {
        title: `Este distrus coronavirusul de inhalarea de aer fierbinte ?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 26 Martie 2020 </p>
            <p>
              <strong> NU.</strong>
            </p>
            <p>
              Nu există dovezi științifice care să arate că inhalarea de aer fierbinte ar distruge coronavirusul. Informația este fals atribuită Organizației Mondiale a Sănătății.
            </p>
            <p>
              O informație fals atribuită Organizației Mondiale a Sănătății circulă pe internet în ultimele zile. Conform acesteia, inhalarea de aer cald din interiorul unei saune sau cu ajutorul unui uscător de păr poate ucide coronavirusul înainte ca acesta să producă infecția. Acest tip de informație se încadrează în categoria de știri false care oferă soluții mult simplificate pentru probleme cu o complexitate mare.
            </p>
            <p>
              Nu există dovezi științifice care să confirme distrugerea coronavirusului aflat deja în căile respiratorii prin inhalarea de aer fierbinte. Practici neobișnuite, precum inhalarea de aer fierbinte cu ajutorul unui uscător de păr, pot provoca accidente sau leziuni neprevăzute.
              Este foarte important să ne informăm doar din surse oficiale și să nu cădem pradă soluțiilor miraculoase apărute pe internet.
            </p>
            <p>
            Cele mai importante măsuri de prevenție pentru infecția cu noul coronavirus sunt reducerea contactului cu alte persoane și spălatul pe mâini, cel puțin 30 de secunde, ori de câte ori este necesar.
            </p>
          `,
      },
      {
        title: `Pierderea gustului/mirosului este un simptom în COVID-19?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 26 Martie 2020 </p>
            <p>
              Pierderea mirosului și a gustului pot apărea în cazul infecţiei cu coronavirus. <strong> Încă nu ştim  </strong> cât de comune
              sunt aceste simptome.
            </p>
            <p>
              Datele apărute în ultimele zile arată o posibilă legătură între pierderea mirosului și infecția cu coronavirus, însă este nevoie de studii amănunțite pentru a stabili
              cât de comun este acest simptom și în ce stadiu al infecției poate să apară. Organizația Mondială a Sănătății nu a confirmat încă aceste date,
              însă Academia Americană de Otolaringologie recomandă ca, în cazul pierderii mirosului și în lipsa altor factori precum sinuzite,
              rinite sau alergii, ar trebui luate în considerare autoizolarea și testarea pentru coronavirus.
               Până la confirmarea acestor informații, trebuie să știm că cele mai comune simptome ale bolii COVID-19 sunt tusea, febra și dificultățile în respirație.
            </p>
            <p>
              Pierderea temporară a mirosului (anosmia) este un simptom comun în multiple viroze respiratorii; virusurile atacă mucoasa nazală, cauzând congestie,
              creșterea secrețiilor nazale și inflamația mucoasei, unde se găsesc receptorii olfactivi.
              Anosmia poate fi cauzată și de diverse alergii sau de tratamentul cu antibiotice sau medicamente pentru reglarea tensiunii arteriale.
            </p>
            <p>
              În ultimele zile, pierderea mirosului si a gustului au fost raportate la pacienți din întreaga lume confirmați ulterior ca fiind infectați
              cu coronavirus, deși nu prezentau alte simptome. În Coreea de Sud, unde testarea populației este extinsă, 30% din pacienții pozitivi dar asimptomatici au prezentat pierderea mirosului și a gustului. Dovezi au apărut și în alte țări precum China, SUA, Iran, Italia și Germania. Experți recunoscuți din Marea Britanie și SUA afirmă că pierderea mirosului
              și a gustului pot fi indicatori ai infecției asimptomatice cu coronavirus sau pot fi considerate simptome timpurii ale bolii.
            </p>
          `,
      },
      {
        title: `Fumatul este un factor de risc pentru COVID-19?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 25 Martie 2020 </p>
            <p>
              <strong> DA.</strong>
            </p>
            <p>
              Fumatul sau vaping-ul reprezintă un factor de risc în cazul COVID-19, atât prin creșterea riscului de infectare, cât și prin evoluția spre forme severe.
            </p>
            <p>
              Organizația Mondială a Sănătății avertizează că atât mâinile, cât și țigările pot fi contaminate, iar prin aducerea lor în mod repetat la nivelul gurii este
              favorizată infectarea. În plus, fumatul conduce la creșterea numărului receptorilor pe care noul coronavirus
              îi folosește pentru a intra în celule și a le infecta, ceea ce crește riscul de infectare la fumători.
            </p>
            <p>
              Consumul de alte produse pe bază de tabac (narghilea), favorizează transmiterea de la o persoană la alta, mai ales prin folosirea de piese bucale și furtunuri nesterile.
            </p>
            <p>
              Fumătorii prezintă anumite anomalii la nivelul plămânilor (inflamație, fibroză), care împiedică buna funcționare a acestora în condiții normale. În cazul unei infecții, inclusiv cu noul coronavirus, riscul de a dezvolta o
              formă severă de boală este crescut în cazul fumătorilor din cauza anomaliilor deja existente la nivelul plămânilor.
            </p>
            <img src=${require("../images/mituri/fumatul.jpeg")} alt="despre riscul fumatului" > </img>
          `,
      },
      {
        title: `Există o legătură între vaccinul antigripal și coronavirus?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 25 Martie 2020 </p>
            <p>
              <strong> NU.</strong>
            </p>
            <p>
              Vaccinul antigripal nu favorizează si nici nu protejează contra COVID-19 deoarece este vorba de două virusuri diferite.
            </p>
            <p>
              Persoanele cu risc crescut pentru boala COVID-19 sunt în mare măsură aceleași ca în cazul gripei: persoanele în vârstă, persoane cu boli cronice, excepție făcând copiii.
              O știre din media britanică a fost greșit citată și s-a transformat într-o știre falsă. Nu există date științifice care să facă vreo legătură între coronavirus și vaccinul antigripal.
              Este ușor de înțeles de ce: vaccinul antigripal țintește un alt virus, cel gripal, în timp ce coronavirusul este un virus cu o structură diferită.
              Totuși, în contextul epidemiei de coronavirus în care spitalele pot deveni suprasolicitate, vaccinarea antigripală poate
              fi utilă pentru că reduce numărul cazurilor complicate de gripă care ar necesita spitalizare, iar pacienții cu COVID-19 pot fi detectați mai eficient.
            </p>
          `,
      },
      {
        title: `Coronavirusul se poate transmite prin tuse sau stranut?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 24 Martie 2020 </p>
            <p>
              <strong> DA.</strong>
            </p>
            <p>
              Picaturile eliminate cand o persoana cu COVID-19 tuseste, stranuta sau vorbeste pot transmite coronavirusul persoanelor din apropiere.
            </p>
            <p>
              Picaturile fine eliminate atunci cand o persoana infectata cu coronavirus tuseste, stranuta sau vorbeste contin particule viabile de coronavirus.
              Acestea pot transmite infectia daca intra in contact cu ochii, gura sau mucoasa nazala ale altor persoane. Conform rezultatelor unui experiment de laborator publicat săptămâna trecută,
              astfel de particule fine continand coronavirus pot transmite infectia inclusiv dupa 3 ore de la expulzare. Pentru a reduce riscul infectarii proprii
              si a celorlalti, sunt absolut necesare respectarea normelor de igiena recomandate (spalat des pe maini, acoperirea gurii la stranut/tuse cu un servetel)
              si pastrarea unei distante de cel putin trei pasi mari fata de ceilalti.
            </p>
            <img src=${require("../images/mituri/tuse-stranut.jpeg")} alt="despre tuse stranut" > </img>
          `,
      },
      {
        title: `Sunt gravidele puse în pericol de coronavirus?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 23 Martie 2020 </p>
            <p>
              <strong> DA.</strong>
            </p>
            <p>
              Nu știm cu certitudine cât de afectate sunt gravidele de infecția cu coronavirus. Se recomandă precauție mărită şi distanțare socială riguroasă.
            </p>
            <p>
              În general gravidele sunt mai predispuse să dezvolte complicații atunci când au boli respiratorii, indiferent de tipul acestora. Deocamdată nu știm cu siguranță dacă și în ce
              fel sunt afectate gravidele de infecția cu coronavirus. Datele preliminare disponibile în prezent provin din observarea unui număr redus de gravide în trimestrul 3 de sarcină
              confirmate cu coronavirus. Pe baza acestor date preliminare se pare că manifestările coronavirusului nu sunt mai grave la gravide decât la persoanele infectate care au aceeași
              vârstă și istoric medical. Totodată, se pare că virusul nu se transmite prin placentă de la gravida cu infecție confirmată la făt. Pentru a confirma însă cu siguranță aceste observații
              este nevoie de mai multe studii. Lipsesc datele cu privire la efectele infecției cu coronavirus la gravidele aflate în primul trimestru de sarcină.
              De aceea, se recomandă precauție mărită la gravide pe perioada pandemiei prin izolare la domiciliu și reducerea drastică a contactelor sociale.
              Vă vom ține la curent pe măsură ce vor apărea date științifice noi pe acest subiect.
            </p>
          `,
      },
      {
        title: `Cât durează să te vindeci de coronavirus?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 21 Martie 2020 </p>
            <p>
              Depinde de severitatea simptomelor: de la 2 săptămâni până la 6 săptămâni.
            </p>
            <p>
              În cazul persoanelor care fac forma ușoară sau moderată a bolii, vindecarea nu apare mai devreme de 2 săptămâni de la apariția primelor simptome.
              Pentru persoanele care fac o formă severă a bolii, vindecarea poate dura până la 6 săptămâni, dar cel mai frecvent o lună.
              1 din 5 persoane infectate cu coronavirus vor dezvolta o formă severă a bolii. Date fiind duratele lungi necesare vindecării,
              în cazul unui număr mare de persoane infectate cu coronavirus există riscul semnificativ al aglomerării spitalelor și chiar a depășirii capacității lor.
              Astfel de fenomene sunt întâlnite în Italia sau în China. De aceea este esențial să încetim ritmul de infecție cu coronavirus pentru a evita suprasolicitarea medicilor și
              asistenților noștri medicali. Cea mai eficientă metodă dovedită prin care putem face asta este micșorarea contactelor sociale. Vă rugăm evitați contactul direct cu alte persoane,
              evitați deplasările și zonele aglomerate, păstrați o distanță de cel puțin 1,5 metri (cât 3 pași) față de alte persoane. Doar împreună ne putem apăra de acest virus.
            </p>
            <img src=${require("../images/mituri/cat-dureaza-sa-te-vindeci.jpeg")} alt="despre vindecare" > </img>
          `,
      },
      {
        title: `Pot fi infectat cu coronavirus chiar dacă nu am simptome?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 20 Martie 2020 </p>
            <p>
              <strong> DA.</strong>
            </p>
            <p>
              Chiar şi cei care nu manifestă simptome pot fi infectaţi cu coronavirus și pot transmite infecţia mai departe.
            </p>
            <p>
              Perioada în care o persoană răspândește virusul poate începe cu până la 2 zile ‼️ înainte de apariția primelor semne ale bolii, aceasta fiind cea mai intensă la începutul bolii.
              Persoanele infectate pot răspândi virusul până la 7 - 12 zile după apariția primelor simptome.
            </p>
            <p>
              În aceste condiții, este esențial să luăm măsuri pentru a limita transmiterea bolii:
            </p>
             <ul style="list-style-type:none;">
              <li><span style="margin-right:10px; font-weight: 400;
              font-family: apple color emoji,segoe ui emoji,noto color emoji,android emoji,emojisymbols,emojione mozilla,twemoji mozilla,segoe ui symbol;">1️⃣</span>Evitați contactul direct cu alte persoane!</li>
              <li><span style="margin-right:10px; font-weight: 400;
              font-family: apple color emoji,segoe ui emoji,noto color emoji,android emoji,emojisymbols,emojione mozilla,twemoji mozilla,segoe ui symbol;">2️⃣</span>Evitați deplasările și zonele aglomerate!</li>
              <li><span style="margin-right:10px; font-weight: 400;
              font-family: apple color emoji,segoe ui emoji,noto color emoji,android emoji,emojisymbols,emojione mozilla,twemoji mozilla,segoe ui symbol;">3️⃣</span>Păstrați o distanță de cel puțin 1,5 metri (cât 3 pași) față de alte persoane!</li>
              <li><span style="margin-right:10px; font-weight: 400;
              font-family: apple color emoji,segoe ui emoji,noto color emoji,android emoji,emojisymbols,emojione mozilla,twemoji mozilla,segoe ui symbol;">4️⃣</span>Spălați-vă frecvent pe mâini timp de 20-30 de secunde (cât durează să cântăm prima strofă din Deșteaptă-te Române!).</li>
              <li><span style="margin-right:10px; font-weight: 400;
              font-family: apple color emoji,segoe ui emoji,noto color emoji,android emoji,emojisymbols,emojione mozilla,twemoji mozilla,segoe ui symbol;">5️⃣</span>Nu vă atingeți fața, ochii, nasul sau gura fără a fi riguros spălat pe mâini!</li>
              <li><span style="margin-right:10px; font-weight: 400;
              font-family: apple color emoji,segoe ui emoji,noto color emoji,android emoji,emojisymbols,emojione mozilla,twemoji mozilla,segoe ui symbol;">6️⃣</span>Dezinfectați suprafețele cu care intrați în contact în mod frecvent!</li>
            </ul>
            <p>
              🔴 În caz că manifestați simptome specifice, izolați-vă și apelați medicul de familie sau Direcția de Sănătate Publică! Apelați 112 doar în caz de urgență!
            </p>
            <p>
              🙏 Este necesar un efort colectiv pentru a depăși această situație cu un număr cât mai mic de îmbolnăviri. Respectați recomandările medicale pentru a vă îngriji de sănătatea dumneavoastră și a celor dragi!
            </p>
          `,
      },
      {
        title: `Tratamentul homeopat vindecă sau previne coronavirusul?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 19 Martie 2020 </p>
            <p>
              <strong> NU.</strong>
            </p>
            <p>
              Remediile homeopate nu au efect în prevenirea sau tratarea coronavirusului. Luaţi medicamente numai la recomandarea medicului!
            </p>
            <p>
              Mai multe informații false despre folosirea remediilor homeopate în infecția cu coronavirus au început să circule pe internet. Aceste informații nu au nicio bază științifică.
            </p>
            <p>
              ‼️Nu vă lăsați păcăliți. Picăturile homeopate sau alte preparate similare nu sunt recomandate pentru coronavirus. Pentru prevenirea sau tratarea coronavirusului, folosirea produselor homeopate în detrimentul măsurilor indicate de medici vă pot pune viața în pericol.
            </p>
          `,
      },
      {
        title: `Este sigur să donez sânge în contextul actual?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 19 Martie 2020 </p>
            <p>
              <strong> DA.</strong>
            </p>
            <p>
              România are mare nevoie de donatori de sânge! Donarea de sânge se realizează în condiţii de siguranță, luându-se măsuri suplimentare pentru a împiedica transmiterea coronavirusului.
            </p>
            <p>
              La nivelul centrelor de transfuzie s-au luat măsuri suplimentare pentru siguranța donatorilor, a personalului centrelor și a persoanelor la care vor ajunge
              produsele sanguine. Există consens la nivel internațional asupra siguranței transfuziilor sanguine în circumstanțele actuale ale pandemiei cu noul coronavirus.
            </p>
            <p>
              ‼️În toate centrele de donare din țară există un punct de triere unde se măsoară temperatura, se investighează istoricul de călătorie, posibilul contact cu persoane infectate și posibilele simptome ale infecției.
            </p>
            <p>
              ‼️Donatorii primesc măști, se supraveghează dezinfecția riguroasă a mâinilor, se dezinfectează regulat spațiile de donare și se asigură distanțarea optimă a donatorilor.
            </p>
            </p>
            <p>
              ⭕ Nevoia de sânge nu se oprește odată cu declanșarea pandemiei de coronavirus. Este foarte important ca activitatea de donare de sânge să continue! Dacă nu ați călătorit în afara țării în ultimele 28 de zile,
              nu ați intrat în contact cu persoane infectate și nu prezentați simptome specifice infecției cu coronavirus, vă rugăm să donați sânge.
            </p>
            <p>
              ⭕ Există posibilitatea programării de la distanță pentru donarea de sânge, telefonic, prin email sau prin intermediul unor aplicații mobile precum Donorium.
            </p>
            <p>
              Donează sânge! Generozitatea ta poate salva viețile altor oameni.
            </p>
          `,
      },
      {
        title: `Este (hidroxi)clorochina un tratament promițător în COVID-19?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 19 Martie 2020 </p>
            <p>
              Acţiunea (hidroxi)clorochinei este studiată şi rezultate clare sunt așteptate peste câteva săptămâni.
            </p>
            <p>
              În cazul apariției unor infecții foarte noi, cum este coronavirusul, este necesară o perioadă de timp pentru descoperirea și testarea unor terapii care să vindece infecția. Aceste terapii trebuie să facă mai mult bine decât rău și de aceea studiile clinice solide sunt foarte importante.
            </p>
            <p>
              ‼️Este important ca orice medicament să fie luat doar la indicația medicului, nu în urma sfaturilor de pe internet.
            </p>
            <p>
              (Hidroxi)clorochina este un medicament folosit împotriva malariei. În prezent, trei studii clinice mari sunt în desfășurare în privința eficienței acesteia în tratarea infecției cu coronavirus, dar va mai dura o perioadă până la apariția unor rezultate. Un studiu experimental a demonstrat eficiența ei asupra coronavirusului, dar în condiții de laborator. Numărul studiilor care au demonstrat impactul pozitiv al administrării (hidroxi)clorochinei la pacienți cu coronavirus este scăzut deocamdată, iar validitatea lor științifică este limitată.
            </p>
            <p>
              Vă vom ține la curent în privința evoluțiilor rapide din domeniu.
            </p>
          `,
      },
      {
        title: `Pot să mă infectez cu coronavirus de două ori?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 18 Martie 2020 </p>
            <p>
              Nu există dovezi care să ateste că o persoană poate să se re-infecteze cu noul coronavirus.
            </p>
            <p>
              Oamenii de știință afirmă că, după trecerea printr-o astfel de infecție, o persoană dezvoltă imunitate la aceasta.
              Informația a fost confirmată într-un cadru oficial de unul dintre cei mai reputați imunologi americani.
            </p>
            <p>
              Pentru a menține rigurozitatea științifică a informării: deocamdată este prea devreme în derularea epidemiei pentru ca suficiente studii
              științifice pe acest subiect să fi fost publicate. Teoretic există posibilitatea ca unele persoane cu deficiențe imune să se re-infecteze cu coronavirus.
            </p>
          `,
      },
      {
        title: `Pot lua ibuprofen dacă am coronavirus?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 18 Martie 2020 </p>
            <p>
              Încă neclar. Nu există studii privind efectele administrării de ibuprofen asupra pacienţilor cu COVID-19. Dacă aveţi febră, luaţi medicamente doar la recomandarea medicului!
            </p>
            <p>
              Specialiștii Organizației Mondiale a Sănătății sunt în proces de evaluare a efectelor administrării de ibuprofen la pacienții cu coronavirus.
            </p>
            <p>
              Ipotezele emise de experți francezi au avertizat asupra unor posibile efecte adverse ale administrării de ibuprofen la pacienții cu coronavirus.
            </p>
            <p>
              Pe 17 martie 2020, Serviciul Național de Sănătate din Marea Britanie (NHS) a anunțat că nu există dovezi suficient de puternice că ibuprofen agravează COVID19. Până la apariția de noi date științifice,
              aceștia au actualizat recomandările privind tratamentul simptomelor infecției cu coronavirus. Este recomandat paracetamolul, cu excepția cazurilor în care un
              medic recomandă explicit altceva. Același ghid le recomandă pacienților aflați în tratament cu ibuprofen să ❗️ NU ❗️ întrerupă administrarea de ibuprofen fără consultarea medicului.
            </p>
          `,
      },
      {
        title: `Mă pot infecta de pe suprafața fructelor sau legumelor?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 18 Martie 2020 </p>
            <p>
              Coronavirusul poate rezista pe diferite suprafeţe, dar încă nu există dovezi care să susţină transmiterea prin intermediul fructelor şi legumelor neambalate. Chiar şi aşa, spălaţi bine fructele și legumele!
            </p>
            <p>
              Nu a fost raportat nici un caz de transmitere al coronavirusului prin intermediul mâncării. Înainte de a pregăti mâncarea sau de a mânca este foarte important să ne spălăm pe mâini minimum 20 - 30 de secunde (cam cât durează să cântăm prima strofă din Deșteaptă-te Române!).
            </p>
            <p>
              Este de așteptat ca prepararea termică riguroasă a alimentelor să elimine riscul de infectare al acestora.
            </p>
            <p>
              Principalul mod de transmitere al infecției cu noul coronavirus este de la persoană la persoană. Transmiterea prin contactul cu suprafețe contaminate este și ea posibilă.
            </p>
            <img src=${require("../images/mituri/infectare-fructe-legume.jpeg")} alt="infectare fructe legume" > </img>
          `,
      },
      {
        title: `Dacă am febră sau tuse trebuie să merg la spital?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 17 Martie 2020 </p>
            <p>
              <strong> NU.</strong>
            </p>
            <p>
              Evitaţi contactul cu alte persoane și sunaţi la medicul de familie sau la Direcţia de Sănătate Publică din judeţ. În caz de urgenţă apelaţi 112.
            </p>
            <p>
              În cazul în care manifestați simptome specifice infecției cu coronavirus (tuse, febră, dificultăți în respirație) este important să nu vă deplasați la medic sau la spital/urgență.
            </p>
            <p>
              ‼️Primul pas este să vă sunați medicul de familie și să solicitați indicații. În cazul în care acesta nu poate fi contactat, apelați Direcția de Sănătate Publică din județul dumneavoastră. În caz de urgență apelați 112.
            </p>
            <p>
              Dacă aveți simptome specifice, efectuarea unui test pentru coronavirus nu este obligatorie și nici urgentă. Decizia de a efectua acest test aparține medicilor de specialitate în funcție de specificul fiecărui caz în parte.
            </p>
            <p>
              ‼️Evitați contactul cu alte persoane pentru a nu le expune la riscul de infectare. Transmiterea infecției de la persoane asimptomatice este posibilă.
            </p>
            <img src=${require("../images/mituri/ce-sa-fac-daca-am-febra.jpeg")} alt="ce sa fac daca am febra"> </img>
          `,
      },
      {
        title: `Coronavirusul are o variantă blândă şi una rea?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 16 Martie 2020 </p>
            <p>
              <strong> NU.</strong>
            </p>
            <p>
              Au fost izolate două subtipuri diferite ale virusului. Nu există nicio dovadă că acestea ar produce simptome ale bolii de severităţi diferite.
            </p>
            <p>
              Este normal ca orice virus să prezinte în timp diferite subtipuri. Un studiu pe un număr limitat de cazuri a identificat două subtipuri ale coronavirusului, tipul L și tipul S, dar diferențele între ele sunt mici.
            </p>
            <p>
              În prezent, nu există nicio dovadă științifică că aceste diferențe ar provoca simptome mai severe ale bolii pentru un subtip comparativ cu celălalt.
            </p>
            <p>
              În prezent, nu există nicio dovadă științifică că subtipurile prezente în România ar fi mai blânde sau mai agresive decât în alte țări.
            </p>
          `,
      },
      {
        title: `Dacă beau apă la fiecare 15 minute, mă feresc de COVID-19?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 16 Martie 2020 </p>
            <p>
              <strong> NU.</strong>
            </p>
            <p>
              Nu există dovezi care să confirme că infecţia cu coronavirus ar putea fi prevenită prin consumul regulat de apă.
            </p>
            <p>
              O informaţie fals atribuită cercetătorilor de la Stanford, circulă online în ultimele zile. Potrivit acesteia, dacă bem apă la fiecare
              15 minute virusul ajunge în stomac unde este neutralizat, în loc să ajungă în căile respiratorii.
              Acest tip de informație se încadrează în categoria de știri false care oferă soluții mult simplificate pentru probleme cu o complexitate mare.
            </p>
            <p>
              ❗️Hidratarea organismului este importantă în orice condiții, indiferent de contextul epidemiologic actual.
                Consumați zilnic o cantitate suficientă de apă, adaptată la greutatea dumneavoastră și la nivelul de efort fizic depus.
            </p>
            <p>
              ❗️Este important ca orice tratament să fie luat doar la indicația medicului, nu în urma sfaturilor de pe internet.
            </p>
            <p>
              Cele mai importante măsuri de prevenție pentru infecția cu noul coronavirus sunt reducerea contactului cu alte persoane și spălatul pe mâini, cel puțin 30 de secunde, ori de câte ori este necesar.
            </p>
            <img src=${require("../images/mituri/ajuta-sa-beau-apa.jpeg")} alt="ajuta sa beau apa"> </img>
          `,
      },
      {
        title: `Există vaccin sau tratament pentru coronavirus?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 15 Martie 2020 </p>
            <p>
              <strong> NU.</strong>
            </p>
            <p>
              În prezent nu există vaccin și încă nu a fost descoperit un tratament eficient. Este important ca orice medicament să fie luat doar la indicația medicului, nu în urma sfaturilor de pe internet.
            </p>
            <p>
              Peste 11 echipe științifice din toată lumea lucrează acum la dezvoltarea unui vaccin împotriva noului coronavirus.
              Măsurile de igienă și limitarea deplasărilor în spații publice sunt cele mai eficiente metode pentru prevenirea răspândirii epidemiei.
            </p>
            <p>
              Patru medicamente antivirale folosite deja în alte boli sunt astăzi studiate pentru a se confirma dacă sunt utile pentru tratamentul COVID-19.
            </p>
            <img src=${require("../images/mituri/exista-vaccin-sau-tratament.jpeg")} alt="exista vaccin sau tratament ?"> </img>
          `,
      },
      {
        title: `Trebuie evitate mijloacele de transport în comun aglomerate?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 15 Martie 2020 </p>
            <p>
              <strong> DA.</strong>
            </p>
            <p>
              Spaţiile închise și aglomerate, precum autobuzul sau metroul, favorizează transmiterea coronavirusului.
            </p>
            <p>
              Folosirea mijloacelor aglomerate de transport public vă poate crește riscul de expunere la coronavirus.
              Dacă aveţi opţiunea de a merge pe jos sau cu bicicleta, este recomandat să nu folosiţi transportul în comun.
              Dacă sunteţi în vârstă sau aveți o boală cronică, căutați mijloace de transport alternative - prezenţa dumneavoastră într-un mijloc de
              transport poate crește semnificativ riscul de infecție.
            </p>
            <p>
              Încercați să reduceți deplasările în această perioadă, dacă este posibil.
            </p>
            <p>
              Evitaţi autobuzele / metroul în caz de aglomeraţie. Lăsaţi să treacă autobuzele aglomerate și așteptați unul mai puțin aglomerat.
            </p>
            <p>
              Staţi la minimum 1.5 metri distanţă (cât doi pași mari) de ceilalţi pasageri, dezinfectaţi-vă pe mâini înainte, în timpul şi imediat după călătorie.Folosiţi un şerveţel pentru a vă ţine de stâlp,
              evitaţi să vă atingeţi faţa şi folosiți dezinfectant pentru mâini dacă îl aveți în timp ce mergeţi cu trenul, autobuzul, metroul sau tramvaiul.
            </p>
            <p>
              Este recomandabil să vă anulați călătoriile în această perioadă.
            </p>
          `,
      },
      {
        title: `Vitamina C și coronavirusul`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 14 Martie 2020 </p>
            <p>
              Nu există dovezi că Vitamina C ajută la prevenirea sau tratamentul infecţiei cu coronavirus.
            </p>
            <p>
              Vitamina C este un micronutrient esențial pentru buna funcționare a organismului nostru. Doza zilnică necesară de vitamina C se obține printr-o alimentație echilibrată ce include fructe și legume.
            </p>
            <p>
              Studiile științifice arată că vitamina C poate reduce simptomele într-o răceală obișnuită. În special la persoanele cu carență de vitamină C, poate avea anumite efecte benefice în pneumonii.
            </p>
            <p>
              În prezent, nu există dovezi că vitamina C ajută în prevenirea sau tratamentul infecției cu coronavirus.
            </p>
            <p>
              ℹ️ Supradoza de vitamina C poate cauza reacții adverse precum greață, crampe abdominale și diaree.
            </p>
            <img src=${require("../images/mituri/vitamina-c-si-coronavirusul.jpeg")} alt="vitamina c si coronavirusul"> </img>
          `,
      },
      {
        title: `Coronavirusul provine de la animale?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 13 Martie 2020 </p>
            <p>
              <strong> DA.</strong>
            </p>
            <p>
              Coronavirusul provine dintr-o specie de lilieci din China. Zvonurile că a fost creat în laborator pornind de la HIV sunt complet false.
            </p>
            <p>
              Analiza genetică a coronavirusului arată că originea probabilă a acestuia este o specie de lilieci din China.
              Pangolinul (furnicarul) este gazda intermediară între lilieci și oameni. Nu există nici o altă teorie validă științific în legătură cu proveniența noului virus.
            </p>
            <p>
              Există similarităţi între diverse componente structurale ale noului coronavirus și mai multe alte virusuri (inclusiv HIV).
              Dar aceste asemănări sunt obișnuite şi nu indică faptul că virusul ar fi fost creat în laborator.
            </p>
            <p>
              ➡️ Teoriile conspiraționiste dăunează sănătății! Igiena și precauția, nu.
            </p>
          `,
      },
      {
        title: `Copiii trebuie să evite locurile de joacă aglomerate?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 13 Martie 2020 </p>
            <p>
              <strong> DA.</strong>
            </p>
            <p>
              Copiii trebuie feriţi de locurile de joacă unde obiectele / suprafeţele sunt atinse de un număr mare de copii.
            </p>
            <p>
              Dovezile curente sugerează că noul coronavirus poate rămâne pe suprafețe din diferite materiale pentru ore și chiar zile. De aceea este recomandată ca măsură de precauție evitarea atingerii acelor
              suprafețe care vin în contact cu un număr mare de persoane. Dacă totuși facem asta, atunci trebuie să ne spălăm apoi imediat pe mâini.
            </p>
            <img src=${require("../images/mituri/copiii-sa-evite-locurile-de-joaca.jpeg")} alt="copiii sa evite locurile de joaca"> </img>
          `,
      },
      {
        title: `Spirtul poate ajuta în prevenirea COVID-19?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 13 Martie 2020 </p>
            <p>
              Alcoolul sanitar (etanol 70%) este dezinfectant și poate ajuta în prevenirea coronavirusului. Recomandat în special pentru dezinfectarea suprafeţelor.
            </p>
            <p>
              Organizaţia Mondială a Sănătăţii recomandă folosirea alcoolului sanitar (spirt medicinal) ca măsură de prevenire a infecției cu coronavirus.
            </p>
            <ul style="list-style-type:none; margin-left:0;">
              <li>
                ➡️ Alcoolul sanitar (etanol 70%) poate fi folosit pentru dezinfectarea suprafeţelor atinse frecvent.
              </li>
              <li>
                ➡️ Pentru dezinfectarea mâinilor este recomandată spălarea pe mâini cu săpun timp de minimum 30 de secunde (cam cât durează să cântăm primele 3 versuri din “Deșteaptă-te române!”) sau folosirea de dezinfectant sub formă de gel (cu etanol 70%).
              </li>
            </ul>
            <p>
              ℹ️ Alcoolul sanitar este inclus în registrul național al produselor biocide din România, actualizat în ianuarie 2020.
              Produsul este destinat exclusiv uzului extern, a nu se consuma.
            </p>
          `,
      },
      {
        title: `Consumul de lămâie previne infecția cu coronavirus?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 12 Martie 2020 </p>
            <p>
              <strong> NU.</strong>
            </p>
            <p>
              Consumul de lămâie (proaspătă sau în apă fierbinte) nu previne și nu vindecă infecţia cu coronavirus.
            </p>
            <p>
              Informația potrivit căreia consumul de lămâie și apă fierbinte poate preveni diverse boli circulă pe internet de mai mulți ani, sub diverse forme. Această informație a fost preluată și adaptată infecției cu coronavirus, fără a exista însă vreo dovadă științifică.
            </p>
            <p>
              Altfel, ceaiul cu lămâie are gust bun, ne place și nouă. :)
            </p>
            <img src=${require("../images/mituri/lamaia-si-coronovirusul.jpeg")} alt="lamaia si coronovirusul"> </img>
          `,
      },
      {
        title: `Este preferabil să stăm acasă în această perioadă?`,
        content: `
            <p style="text-transform: uppercase; color: #828282;"> 12 Martie 2020 </p>
            <p>
              <strong>DA.</strong>
            </p>
            <p>
              Reducerea contactului între persoane scade posibilitatea transmiterii virusului.
            </p>
            <p>
              Reducerea contactului între persoane (distanţarea socială) este una din cele mai importante măsuri pe care fiecare dintre noi le poate lua în această perioadă.
            </p>
            <p>
              Evităm zonele aglomerate, păstrăm cel puțin 1 metru și jumătate distanță (cât doi pași mari) în locurile publice față de persoanele din jur, evităm mijloacele de transport în comun aglomerate și, dacă e posibil, lucrăm de acasă.
            </p>
            <p>
              Țările în care aceste măsuri sunt respectate reușesc să controleze mai repede epidemia de coronavirus.
            </p>
            <img src=${require("../images/mituri/sa-stam-acasa.jpeg")} alt="sa stam acasa"> </img>
          `,
      },
    ],
  },
  {
    title: "Călătorim în siguranță",
    slug: "calatorim-in-siguranta",
    doc_type: "STATIC_PAGE",
    doc_id: 303,
    active: true,
    display_order: 2,
    showInTopMenu: true,
    showInSideMenu: true,
    style: { "--highlightColor": "#F6DD62" },
    content: [
      {
        title: "Cum călătorim în siguranță",
        display_order: 1,
        slug: "/",
        page: `
        <p>Comitetul Național pentru Situații de Urgență a stabilit, prin <a href="https://stirioficiale.ro/hotarari/hotararea-nr-6-din-31-01-2022" target="_blank" rel="noopener noreferrer">Hotărârea numărul 6 din 31 ianuarie 2022</a>, faptul că nu va mai fi realizată lista cu clasificarea țărilor/teritoriilor în funcție de rata de incidență cumulată.</p>

        <div style="background-color: #FFD738; padding: 10px;">
        <p>Astfel, la revenirea în România, indiferent de incidența din stattul respective și indiferent dacă este stat UE sau stat terț, persoanele intră în carantină pentru o perioadă de 5 zile dacă nu sunt vaccinate, trecute prin boală sau nu prezintă rezultatul negativ al unui test RT-PCR efectuat cu cel mult 72 de ore înaintea intrării în țară sau îmbarcarii în avion/autocar/tren.</p>
        </div>
       `,
      },
    ],
    firstNodeId: null,
    form: null,
    buttons: null,
    accordion: [
      {
        title: `Întrebări frecvente despre Formularul digital de intrare în România`,
        content: `
            <p><b>Cine completează Formularul digital de intrare în România?</b></p>
            <p>Formularul se completează de către toate persoanele care intră în România și călătoresc cu avionul, trenul, mijloace de transport rutiere sau navale.</p>
            <br>
            <p><b>Unde pot accesa formularul digital de intrare în România?</b></p>
            <p>Formularul digital poate fi generat electronic prin intermediul platformei <a href="https://plf.gov.ro" target="_blank" rel="noopener noreferrer">https://plf.gov.ro</a>, dezvoltată de Serviciul de Telecomunicații Speciale pe baza cerințelor operaționale ale Ministerului Sănătății.</p>
            <p>Pentru eliberarea formularului este necesară autentificarea cu o adresă de e-mail, unde utilizatorul primește un link de acces. Ulterior, se completează câmpurile cu datele solicitate. Pașii sunt similari cu cei pentru generarea certificatului digital UE COVID.</p>
            <p>Platforma <a href="https://plf.gov.ro" target="_blank" rel="noopener noreferrer">https://plf.gov.ro</a> va putea fi accesată de orice persoană, începând cu data de 20 decembrie 2021.</p>
            <br>
            <p><b>Când completez formularul?</b></p>
            <p>Formularul se completează cu maximum 24 de ore înainte de a intra în România sau în termen de 24 de ore de la trecerea frontierei. Acesta poate fi completat electronic de pe telefonul mobil, tabletă sau calculator și nu trebuie tipărit.</p>
            <br>
            <p><b>Ce se întâmplă cu cetățenii care vor veni fără plf?</b></p>
            <p>Persoanele care se prezintă la punctele de trecere a frontierei fără formular vor avea obligativitatea de a-l completa într-un termen de 24 de ore. <b>Necompletarea Formularului digital de intrare în România</b> se sancționează cu amendă de la 2.000 lei la 3.000 lei.</p>
            <br>
            <p><b>Cine verifică plf-ul în punctele de frontieră?</b></p>
            <p>La intrarea în țară, după verificarea cărții de identitate/pașaportului, în sistemul informatic al Poliției de Frontieră va fi afișat dacă persoana a completat formularul.</p>
            <br>
            <p><b>Dacă sunt persoane din aceeași familie care călătoresc împreună, completează toți formularul?</b></p>
            <p>În cazul în care membrii unei familii călătoresc împreună, formularul poate fi completat de un singur membru adult pentru toți membrii familiei.</p>
            <br>
            <p><b>Minorii completează formularul?</b></p>
            <p>Pentru minorii care intră pe teritoriul României, obligația de a completa formularul revine părinților, tutorelui sau reprezentatului legal.</p>
            <br>
            <p><b>Ce date introduc în formular?</b></p>
            <ol>
            <li>CNP și celelalte date de călătorie pentru cetățenii care călătoresc cu carte de identitate românească.</li>
            <li>Datele din pașaport sau din cartea de identitate, pentru persoanele care nu călătoresc în baza cărții de identitate românești.</li>
            </ol>
            <p>Informațiile referitoare la mijloacele de transport sunt cele de pe biletele de călătorie.</p>
            <br>
            <p><b>Trebuie să introduc toate țările prin care am trecut?</b></p>
            <p>În formular se introduc datele despre țara în care am călătorit, dar și cele ale țărilor pe care le-am tranzitat în ultimele 14 zile. Declararea unor date false în Formularul digital de intrare în România intră sub incidența prevederile Codului Penal și se pedepsește conform legii.</p>
            <br>
            <p><b>Dacă am greșit, pot edita formularul?</b></p>
            <p>Odată salvat, formularul nu mai poate fi modificat. Dacă doriți să actualizați informațiile din formular, puteți să îl completați încă o dată și să salvați.</p>
            <p>Toate formularele pe care le-ați completat la intrarea în țara noastră pot fi vizualizate în meniul „Listă formulare” din aplicație.</p>
            <br>
            <p><b>Ce se întâmplă cu formularele după completare?</b></p>
            <p>Formularul ajută personalul medical să realizeze anchetele epidemiologice și să asigure măsurile sanitare în sprijinul populației.</p>
            <p>Pe baza datelor din formular, direcțiile de sănătate publică vor putea identifica și lua legătura mai ușor cu persoanele care au intrat în contact, în timpul călătoriei, cu un cetățean infectat cu virusul SARS-CoV-2.</p>
            <br>
            <p><b>Unde se stochează datele din formular?</b></p>
            <p>Toate formularele se stochează în infrastructura de comunicații a statului român.</p>
            <p>Datele sunt protejate fizic și juridic și nu sunt transmise către terțe persoane.</p>
            <br>
            <p><b>Cine are acces la datele personale completate în formular?</b></p>
            <p>Datele completate în formular sunt accesate doar de angajații autorizați ai direcțiilor de sănătate publică și pot fi folosite strict cu scopul desfășurării anchetelor epidemiologice.</p>
            <p>STS asigură măsurile specifice de securitate cibernetică ale sistemului informatic de eliberare a formularului digital de intrare în România.</p>
            <br>
            <p><b>Dacă nu am adresă de e-mail cum completez formularul?</b></p>
            <p>persoane apropiate de încredere, pentru a completa formularul cu datele personale. </p>
        `
      }
    ]
  },
];
